import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { Row, Col, Form, Input, Select, message, DatePicker, Table, Spin, Space, Drawer, Modal } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import "moment-timezone";
import { Scrollbars } from 'react-custom-scrollbars';
import { pdf, PDFViewer } from '@react-pdf/renderer';
import { useDispatch, useSelector } from 'react-redux';
import { InfoCircleOutlined, PlusCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons'; // EditOutlined
import { useHistory } from "react-router-dom";
import FeatherIcon from 'feather-icons-react';
import { getDealDatabyAccount, getContactDatabyAccount, QuotesItemListColumn, getDealsyncData } from './Functions/quotesFunctions';
import QuotationPdf from './PdfComponents/QuotationPdf';
import { THEMES } from './PdfComponents/pdfCommon';
import SalesOrderAdd from './salesOrderAdd'
import DetailsPage from '../Pages/DetailsPage/Detailspage';
import QuotesFields from '../Pages/DetailsPage/QuotesFields'
import QuotesRight from '../Pages/DetailsPage/QuotesRight'
import TinyMCEEditor from "../EditorFolder/RichEmailEditor"
import CustomHtmlParser from '../Email/CustomHtmlParser'
import { RelatedDocUpload } from '../Pages/GlobalComponents/RelatedDocUpload'
import { FetchContactDetails, FetchContactByDeal } from '../../../Api/Services/ContactApiService'
import { FetchAllSalesOrder } from '../../../Api/Services/SalesOrderApiService'
import { FetchAllAccount, FetchAccountDetails } from '../../../Api/Services/AccountApiService'
import { FetchDealDetails, FetchDealByAccount } from '../../../Api/Services/DealApiService'
import { fetchFileAsBufferFile, getAllUsersData } from '../../../Api/Services/CommonApiService'
import { CompanyDataByUser } from '../../../Api/Services/CompanyApiService'
import { getCompanyQuotes, createQuotes, updateQuotes, deleteQuotes, FetchQuoteDetails } from '../../../Api/Services/QuotesApiService'
import { AddUser } from '../style';
import { setEditCall, setReDirCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
// import { PageHeader } from '../../../components/page-headers/page-headers';
// import { Cards } from '../../../components/cards/frame/cards-frame';
import ComposeMail from '../Email/QSICompose';
import { ExchangeCurrency, convertCurrency, useExcryptedNavigation, useNavigationDecrypted } from '../Filters/FilterConditions';
import { Main, BasicFormWrapper, OrderSummary } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import Heading from '../../../components/heading/heading';
import AllCancelPopup from '../Popup/AllCancelPopup';
import UpdateConnectionPopup from '../Popup/UpdateConnectionPopup';
import DefaultMessagePopup from '../Popup/DefaultMessagePopup'
import ConfirmationPopup from '../Popup/ConfirmationPopup'
import DeleteConnectionPopup from '../Popup/DeleteConnectionPopup';
import AddressPopup from '../Popup/AddressPopup'
import { DeleteIcon, EmailIcon, PdfDownloadIcon, QUSOINIcon, ViewDetailsIcon, SaveIcon, CancelIcon, EditIcon } from '../../../components/Icons/Icons';
import { validateShortText } from '../../../components/utilities/utilities';

const { Option } = Select;

function AddNew({ UrlId, FromPage, setCratePage, GetAll, dataForDeal, ShortCut, CallBackTrigger }) {
    const scrollRef = useRef(null);
    const getFieldPopupContainer = (triggerNode) =>
        scrollRef.current?.view ||
        triggerNode.closest('.ant-drawer-content') ||
        triggerNode.closest('.ant-modal-content') ||
        document.body;
    const normalizeValue = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return null;
        return trimmed ?? value;
    };
    const prevValues = useRef({ UrlId: "", FromPage: "" });
    const { emailactiontype } = useSelector((state) => state.EmailData);
    const dispatch = useDispatch();
    const localData = useSelector((state) => state.localRedux);
    const Role = localData.role
    const companyProfile = localData.company
    const defaultCurrency = localData.currency
    const ProfileData = localData.profile
    const profile = ProfileData
    const loadingRef = useRef(false);
    const [doubleClick, setDoubleClick] = useState(false)
    const history = useHistory();
    const [form] = Form.useForm();
    const [pages] = useState("Meeting")
    const [FILEList, setFileList] = useState([]);
    const [editField, setEditField] = useState(false)
    const [users, setUsers] = useState([])
    const ConvertRates = defaultCurrency?.exchangeRate;
    const CurencyDecimalPlace = defaultCurrency?.decimalOfCurrency;
    const [conatactDetails, setConatactDetails] = useState()
    const [displayData, setDisplayData] = useState()
    const [createPageQuote, setCratePageQuote] = useState()
    const [dataForQuote, setDataForQuote] = useState()
    const [edit, setEdit] = useState(false)
    const [account, setAccount] = useState([])
    const [accountJsonData, setAccountJsonData] = useState()
    const [deal, setDeal] = useState([])
    const [contact, setContact] = useState([])
    const [quotesId, setQuotesId] = useState()
    const [companyData, setCompanyData] = useState()
    const [content1, setContent1] = React.useState();
    const [content2, setContent2] = React.useState();
    const [confirmPopup, setConfirmPopup] = useState(false)
    // const [disableFileds, setDisableFileds] = useState(false)
    const [deleteId, setDeleteId] = useState()
    // const [dealValue, setDealValue] = useState()
    const [billingAddress, setBillingAddress] = useState({})
    const [shipingAddress, setShipingAddress] = useState({})
    const [dealType, setDealType] = useState()
    const [items, setItems] = useState([])
    const [popupOpen, setPopupOpen] = useState(false)
    const [popupType, setPopupType] = useState()
    const [uiReady, setUiReady] = useState(false)
    const [popupContent, setPopupContent] = useState()
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const ConvertRate = defaultCurrency?.exchangeRate;
    const [ProductColumns, setProductColumns] = useState([])
    const [dealDiscount, setDealDiscount] = useState()
    const [total, setTotal] = useState()
    const [grandTotal, setGrandTotal] = useState()
    const [tax, setTax] = useState(0)
    const [adjustment, setAdjustment] = useState(0)
    const [shippingss, setShipping] = useState(0)
    const [accountId, setAccountId] = useState(null)
    const [attachFile, setAttachFile] = useState()
    const [allList, setAllList] = useState([])
    const [validDate, setValidDate] = useState(null)
    const [issueDate, setIssueDate] = useState(null)
    const [popupMessage, setPopupMessage] = useState(false)
    const [mailOpen, setMailOpen] = useState(false)
    const [salesOrderData, setSalesOrderData] = useState([])
    const [errorData, setErrorData] = useState([])
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const Billing = Object.entries(billingAddress)
        .filter(([key]) => key !== 'email' && key !== 'mobile')
        .some(([, value]) => value);
    const Shipping = Object.entries(shipingAddress)
        .filter(([key]) => key !== 'email' && key !== 'mobile')
        .some(([, value]) => value);
    const isObject = (obj) => obj && typeof obj === "object";
    const normalizeForComparison = (val1, val2) => {
        if (typeof val1 === "number") {
            const num2 = Number(val2);
            return [val1, Number.isNaN(num2) ? val2 : num2]; // ✅ replaced isNaN with Number.isNaN
        }
        if (typeof val1 === "string" && val1.trim() !== "" && !Number.isNaN(Number(val1)) && typeof val2 === "number") {
            return [Number(val1), val2]; // ✅ also using Number.isNaN here
        }
        return [val1, val2];
    };
    const PageCancel = () => {
        dispatch(setEditCall(false))
        history.push('/Home/quotes')
    }
    const deepEqual = (obj1, obj2, ignoreKeys = []) => {
        // ✅ CHANGED: added normalization step for non-object values
        if (!isObject(obj1) || !isObject(obj2)) {
            const [val1, val2] = normalizeForComparison(obj1, obj2);
            return val1 === val2;
        }

        // Handle arrays (same as before)
        if (Array.isArray(obj1) && Array.isArray(obj2)) {
            if (obj1.length !== obj2.length) return false;
            return obj1.every((item, i) => deepEqual(item, obj2[i], ignoreKeys));
        }

        // Handle objects (same as before)
        const keys1 = Object.keys(obj1).filter((k) => !ignoreKeys.includes(k));
        const keys2 = Object.keys(obj2).filter((k) => !ignoreKeys.includes(k));

        if (keys1.length !== keys2.length) return false;

        return keys1.every(
            (key) => keys2.includes(key) && deepEqual(obj1[key], obj2[key], ignoreKeys)
        );
    };
    const disabledDate = current => {
        return current && current < moment().startOf('day');
    };
    const onnavigate = () => {
        dispatch(setEditCall(false))
        history.push("/Home/email-config")
    }
    const RequiredDateFormating = (dateString) => {
        if (dateString) {
            const parsedDate = moment(dateString, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
            const formattedDate = parsedDate.format("YYYY-MM-DD");
            return formattedDate;
        }
        return null;
    };
    const scroolup = () => {
        const currentPosition = window.scrollY;
        if (currentPosition > 0) {
            const scrollStep = Math.max(1, Math.ceil(currentPosition / 20));
            window.scrollTo(0, currentPosition - scrollStep);
            requestAnimationFrame(scroolup);
        }
    }
    // const getDaysBetween = (startDate, endDate) => {
    //     const start = new Date(startDate);
    //     const end = new Date(endDate);
    //     const timeDifference = end - start;
    //     const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
    //     return daysDifference;
    // };
    const formatDateString = (dateString, format) => {
        return moment(dateString, "YYYY-MM-DD").format(format);
    };
    const OnClickofDelete = (value) => {
        setConfirmPopup(true)
        setDeleteId(value)
    }
    const validateCode = (_, value) => {
        const allowedRegex = /^[A-Za-z0-9-]+$/;
        if (!/[A-Za-z0-9]/.test(value)) {
            return Promise.reject(
                new Error("Quote number cannot contain only hyphens")
            );
        }
        if (!allowedRegex.test(value)) {
            return Promise.reject(
                new Error("Only letters, numbers, and hyphens (-) are allowed")
            );
        }
        if (value.length > 15) {
            return Promise.reject(
                new Error("Quote number cannot exceed 15 characters")
            );
        }
        const getList = allList
            .filter(item => item.quotesId !== quotesId)
        const existingCodes = getList.map(item => item.quotesNumber)
        if (existingCodes.includes(value)) {
            return Promise.reject(new Error("This number already exists"));
        }
        return Promise.resolve();
    };
    const generateUniqueCode = (Code, existingData) => {
        let newCode;
        const existingCodes = new Set(existingData.map(item => item.quotesNumber));
        do {
            const randomNumber = Math.floor(100000 + Math.random() * 900000);
            newCode = `${Code}-${randomNumber}`;
        } while (existingCodes.has(newCode));
        return newCode;
    };
    const getList = async (type) => {
        try {
            const data = await getCompanyQuotes()
            if (type === "Create") {
                const newCode = generateUniqueCode("QOT", data);
                form.setFieldsValue({
                    number: newCode,
                })
            }
            setAllList(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function GetSalesOrders() {
        try {
            const response = await FetchAllSalesOrder()
            setSalesOrderData(response)
        } catch (error) {
            message.error(error);
        }
    }
    const HandleIsModalVisible = (value) => {
        setIsModalVisible(value)
    }
    async function getAccountData(params) {
        if (params) {
            try {
                const responseData = await FetchAccountDetails(params)
                const Response = responseData.data
                setAccountJsonData(Response)
            } catch (error) {
                message.error(error)
            }
        }
    }
    async function deleteMenu(id) {
        try {
            const response = await deleteQuotes(id)
            if (response.status === 200) {
                if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                    setErrorData(response.data);
                    setIsModalVisible(true);
                    setConfirmPopup(false)
                } else {
                    message.success("Quotes deleted")
                    dispatch(setEditCall(false));
                    history.push('/Home/quotes')
                }
            }
        } catch (error) {
            message.error(error);
        }
    }
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const ViewDetailPage = (id, entity) => {
        dispatch(setReDirCall(null));
        ExcryptedNavigation("Nav", id, entity, history, dispatch, null, null)
    }
    function totalCalculation() {
        let subtotal = 0;
        let discountedTotal = 0;
        let taxTotal = 0;
        let grandTotal = 0;
        const isValidNumber = (val) => val !== "0" && val !== 0 && val !== "" && val !== null && val !== undefined;
        if (items.length > 0) {
            for (let i = 0; i < items.length; i += 1) {
                if (items[i].total) {
                    subtotal += Number(items[i].total);
                }
            }
        }
        if (isValidNumber(dealDiscount)) {
            discountedTotal = subtotal * (1 - Number(dealDiscount) / 100);
        } else {
            discountedTotal = subtotal;
        }
        if (isValidNumber(tax)) {
            taxTotal = discountedTotal * (1 + Number(tax) / 100);
        } else {
            taxTotal = discountedTotal;
        }

        grandTotal = taxTotal;

        if (isValidNumber(adjustment)) {
            grandTotal -= Number(adjustment);
        }

        if (isValidNumber(shippingss)) {
            grandTotal += Number(shippingss);
        }
        setTotal(subtotal?.toFixed(CurencyDecimalPlace));
        setGrandTotal(grandTotal?.toFixed(CurencyDecimalPlace));
    }
    async function getDealData(params) {
        setAccountId(params?.AccountId)
        const dealArray = await getDealDatabyAccount(params?.AccountId, params?.DealId)
        setDeal(dealArray)
        const contactArray = await getContactDatabyAccount(params?.DealId, "")
        setContact(contactArray)
        const dealData = await getDealsyncData(params?.DealId, profile, disabledDate, defaultCurrency, ConvertRates, CurencyDecimalPlace)
        setDealDiscount(dealData?.discount)
        setDealType(dealData?.datas)
        setItems(dealData?.items)
        setProductColumns(dealData?.columns)
        form.setFieldsValue({
            deal: params?.DealId,
            account: params?.AccountId,
        })
    }
    function convertAndFormatDateTime(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const formattedDate = converted.format(dateFormat);
        // const rawTime = converted.format("HH:mm");
        // const formattedTime = convertTime(rawTime, profile?.timeFormat);

        return formattedDate
    }
    async function getContactDe(value) {
        if (value.conatctId) {
            try {
                const responseData = await FetchContactDetails(value.conatctId)
                const contactDetailsDataQ = responseData.data
                setConatactDetails(contactDetailsDataQ)
            } catch (error) {
                setConatactDetails()
                message.error(error)
            }
        }
    }
    const setData = async (value) => {
        if (value) {
            setQuotesId(value.quotesId)
            setAccountId(value.accountId)
            setBillingAddress(value.billingAddress)
            setShipingAddress(value.shippingAddress)
            setValidDate(value.validUntil)
            setIssueDate(value.issueDate)
            const subtotal = value.quotesItem?.subtotalamount
                ? await ExchangeCurrency(Number(value.quotesItem?.subtotalamount), ConvertRates)
                : value.quotesItem.subtotalamount;
            const total = value.quotesItem?.grandTotalamount
                ? await ExchangeCurrency(Number(value.quotesItem?.grandTotalamount), ConvertRates)
                : value.quotesItem.grandTotalamount;
            const adjustent = value.quotesItem?.adjustmentAmount
                ? await ExchangeCurrency(Number(value.quotesItem?.adjustmentAmount), ConvertRates)
                : value.quotesItem?.adjustmentAmount;
            const shipppingdatra = value.quotesItem?.shippingamount
                ? await ExchangeCurrency(Number(value.quotesItem?.shippingamount), ConvertRates)
                : value.quotesItem?.shippingamount;
            setDealDiscount(value.quotesItem?.discountamount)
            setTotal(subtotal)
            setGrandTotal(total)
            setTax(value.quotesItem?.taxAmount)
            setDealType(value.quotesItem?.dealData)
            setAdjustment(Number(adjustent?.toFixed(CurencyDecimalPlace)) || 0)
            setShipping(Number(shipppingdatra?.toFixed(CurencyDecimalPlace)) || 0)
            const convertedRoleData = await Promise.all(
                value.quotesItem?.item.map(async (role) => {
                    const convertedRate = await (role.value !== undefined && role.value !== null && role.value !== ""
                        ? ExchangeCurrency(Number(role.value), ConvertRates)
                        : role.value);
                    const convertedTotalValue = await (role.total !== undefined && role.total !== null && role.total !== ""
                        ? ExchangeCurrency(Number(role.total), ConvertRates)
                        : role.total);
                    return {
                        ...role,
                        value: Number(convertedRate?.toFixed(CurencyDecimalPlace)),
                        total: Number(convertedTotalValue?.toFixed(CurencyDecimalPlace)),
                    };
                })
            );
            setItems(convertedRoleData)
            const QuotesItemArrayColumn = await QuotesItemListColumn(value.quotesItem?.dealData, profile, disabledDate, defaultCurrency, "Quotes");
            setProductColumns(QuotesItemArrayColumn)
            setFileList(value.uploadFile || [])
            const transformedItem = {
                ...value,
                createdAt: value.createdAt ? convertAndFormatDateTime(value.createdAt, companyProfile, profile) : "",
            };
            setDisplayData(transformedItem)
            getContactDe(value)
            form.setFieldsValue({
                subject: value.quotesName,
                number: value.quotesNumber,
                quoteOwner: value.quotesOwner,
                status: value.quotesStatus,
                deal: value.dealId,
                account: value.accountId,
                contact: value.conatctId,
                date: value.validUntil === "" || value.validUntil === null ? null :
                    moment(formatDateString(value.validUntil, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"),
                // description: value.description,
                // termsandCondition: value.termsAndCondition,
                isssueDate: null,
            })
            setContent1(value.termsAndCondition)
            setContent2(value.description)
        }
    }
    const fetchAll3 = async (data) => {
        await Promise.allSettled([
            setData(data),
            getAccountData(data?.accountId),
        ])
    };
    async function getAccoutList(value) {
        if (value.accountId) {
            try {
                const contactArray = await getDealDatabyAccount(value.accountId, value.dealId)
                setDeal(contactArray)
            } catch (error) {
                setDeal([])
                message.error(error)
            }
        } else {
            setDeal([])
        }
    }
    async function getDealList(value) {
        if (value.dealId) {
            try {
                const contactArray = await getContactDatabyAccount(value.dealId, value.conatctId)
                setContact(contactArray)
            } catch (error) {
                setContact([])
                message.error(error)
            }
        } else {
            setContact([])
        }
    }
    async function getData(id) {
        let dataError = true;
        try {
            const response = await FetchQuoteDetails(id);
            dataError = response.allow
            if (!response.allow) throw new Error();
            fetchAll3(response.data);
        } catch (error) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: dataError ? 'error' : 'info',
                content: dataError ? `This record is no longer available. It may have been deleted or moved` : "You don’t have permission to view this record. Please contact your administrator for access",
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: dataError ? 'error' : 'info',
                        content: dataError ? `This record is no longer available. It may have been deleted or moved` : "You don’t have permission to view this record. Please contact your administrator for access",
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const CloseDrawer = () => {
        setCancelConfirmOpen(false)
        form.setFieldsValue({
            subject: null,
            number: null,
            quoteOwner: null,
            status: null,
            deal: null,
            account: null,
            contact: null,
            isssueDate: null,
            date: null,
            // description: null,
            // termsandCondition: null
        })
        setContent1()
        setContent2()
        setAccountJsonData()
        setAccountId()
        setBillingAddress({})
        setShipingAddress({})
        setValidDate(null)
        setIssueDate(null)
        setDealDiscount()
        setTotal()
        setGrandTotal()
        setTax()
        setDealType()
        setAdjustment()
        setShipping(0)
        setDeal([])
        setContact([])
        setItems([])
        setProductColumns([])
        setConatactDetails()
        setFileList([])
        if (FromPage !== "EntityUpdate" && FromPage !== "FromDeal" && ShortCut !== "Shortcut") {
            GetAll();
        }
        if (FromPage !== "EntityUpdate") {
            setCratePage();
        }
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
    }
    const CloseDrawerNew = () => {
        setCancelConfirmOpen(false)
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
    }
    async function getData1(id, hideMessage, updateResponse) {
        let dataError = true;
        try {
            const response = await FetchQuoteDetails(id);
            hideMessage()
            message.success(
                <span>
                    Quote <strong>{updateResponse?.data?.[0]?.entityName}</strong> has been updated successfully
                </span>
            );
            dataError = response.allow
            if (!response.allow) throw new Error();
            fetchAll3(response.data);
            loadingRef.current = false;
            setDoubleClick(false)
            CloseDrawerNew()
        } catch (error) {
            hideMessage()
            loadingRef.current = false;
            setDoubleClick(false)
            message.success(
                <span>
                    Quote <strong>{updateResponse?.data?.[0]?.entityName}</strong> has been updated successfully
                </span>
            );
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: dataError ? 'error' : 'info',
                content: dataError ? `This record is no longer available. It may have been deleted or moved` : "You don’t have permission to view this record. Please contact your administrator for access",
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: dataError ? 'error' : 'info',
                        content: dataError ? `This record is no longer available. It may have been deleted or moved` : "You don’t have permission to view this record. Please contact your administrator for access",
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const { NavigationDecrypted } = useNavigationDecrypted()
    async function getEntityAvalibitlity() {
        let dataFound = true;
        try {
            const response = await NavigationDecrypted(UrlId[1])
            if (response) {
                setQuotesId(response)
                dataFound = true;
                getData(response)
            }
            else {
                dataFound = false;
            }
        } catch (error) {
            dataFound = false;
        }
        if (!dataFound) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    // const fetchFileAsBuffer = async (url) => {
    //     try {
    //         const fileName = url.split('/').pop();
    //         const response = await fetchFileAsBufferFile(fileName)
    //         if (response && response.type === "Buffer" && Array.isArray(response.data)) {
    //             const uint8Array = new Uint8Array(response.data);
    //             const binaryString = uint8Array.reduce((acc, byte) => acc + String.fromCharCode(byte), "");
    //             const base64String = btoa(binaryString);
    //             return `data:image/png;base64,${base64String}`;
    //         }
    //         return null;
    //     } catch (error) {
    //         message.error(error)
    //     }
    // };
    const fetchFileAsBuffer = async (url) => {
        try {
            const response = await fetchFileAsBufferFile(url);
            if (response && response.type === "Buffer" && Array.isArray(response.data)) {
                const uint8Array = new Uint8Array(response.data);
                // Create a Blob from the Uint8Array
                const blob = new Blob([uint8Array]);
                // Create a URL for the Blob (fastest, no base64 conversion needed)
                const objectUrl = URL.createObjectURL(blob);
                return objectUrl;
            }
            return null;
        } catch (error) {
            message.error(error)
            return null;
        }
    };
    const getImageDimensions = (url) =>
        new Promise((resolve) => {
            const img = new window.Image();
            img.onload = () => {
                resolve({ width: img.naturalWidth, height: img.naturalHeight });
            };
            img.onerror = () => {
                resolve(null);
            };
            img.src = url;
        });
    const [pdfTheme, setPdfTheme] = useState('default');
    const handlePdfThemeChange = (value) => {
        setPdfTheme(value);
    };
    const getLogoBoxSize = (naturalWidth, naturalHeight) => {
        if (naturalWidth === naturalHeight) {
            return { width: 70, height: 70 };
        }
        return { width: 100, height: 70 };
    };
    async function getCompanyDetails() {
        try {
            const data = await CompanyDataByUser()
            const base64Image = await fetchFileAsBuffer(data.accountLogo);
            let logoSize = { width: 70, height: 70 };
            if (base64Image) {
                const dims = await getImageDimensions(base64Image);
                if (dims) {
                    logoSize = getLogoBoxSize(dims.width, dims.height);
                }
            }
            const changedData = { ...data, accountLogo: base64Image, logoSize };
            setCompanyData(changedData);
        } catch (error) {
            message.error(error);
        }
    }
    async function getAccount(value) {
        try {
            setAccountId(value)
            getAccountData(value)
            if (value) {
                const data = await FetchDealByAccount(value);
                const options = data.filter(option =>
                    ["Proposal", "Negotiation", "Won", "on-Hold", "On-Hold"].includes(option.pipelineStage)
                ).map((option, i) => (
                    <Option value={option.deals_id} key={i} label={(
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div className='Div_flex2'>
                                <div className='share_image' title={`${option.deal_name} (${option.pipelineStage})`} style={{ cursor: "default" }}>
                                    {option.deal_profile !== null && option.deal_profile !== undefined && option.deal_profile !== "" ?
                                        < img src={option.deal_profile} alt="profile" />
                                        :
                                        <span className="image_icon DealIcon">
                                            {option.deal_name.slice(0, 1).toUpperCase()}
                                        </span>
                                    }
                                    <span className='div-ellipsis'>{option.deal_name}</span>
                                </div>
                            </div>
                        </div>)}>
                        <div className='UserList-dropdown' title={`${option.deal_name} (${option.pipelineStage})`}>
                            <div>
                                {option.deal_profile !== null && option.deal_profile !== undefined && option.deal_profile !== "" ?
                                    < img src={option.deal_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                    :
                                    <span className='details_span_Tag DealIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                        {option.deal_name.slice(0, 1).toUpperCase()}
                                    </span>
                                }</div>
                            <div>
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.deal_name}</p>
                                <p style={{ margin: 0 }}>{option.pipelineStage}</p>
                            </div>
                        </div>
                    </Option>));
                setDeal(options)
                form.setFieldsValue({
                    deal: undefined,
                    contact: undefined,
                })
                setItems([])
                setContact([])
                // setDisableFileds(false)
            } else {
                setItems([])
                setDeal([])
                setContact([])
                // setDisableFileds(false)
                form.setFieldsValue({
                    deal: undefined,
                    contact: undefined,
                })
            }
        }
        catch (error) {
            message.error(error);
        }
    }
    async function getDeal(value) {
        // setDealValue(value)
        form.setFieldsValue({ deal: value || null })
        try {
            if (value) {
                const data = await FetchContactByDeal(value)
                const options = data.map((option, i) => (
                    <Option value={option.contacts_id} key={i} label={(
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div className='Div_flex2'>
                                <div className='share_image' title={`${option.first_name} ${option.last_name} (${option.email})`} style={{ cursor: "default" }}>
                                    {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                        < img src={option.contact_profile} alt="profile" />
                                        :
                                        <span className="image_icon ContactIcon">
                                            {option.first_name.slice(0, 1).toUpperCase()}
                                        </span>
                                    }
                                    <span className='div-ellipsis'>{`${option.first_name} ${option.last_name}`}</span>
                                </div>
                            </div>
                        </div>)} >
                        <div className='UserList-dropdown' title={`${option.first_name} ${option.last_name} (${option.email})`}>
                            <div>
                                {option.contact_profile !== null && option.contact_profile !== undefined && option.contact_profile !== "" ?
                                    < img src={option.contact_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                    :
                                    <span className='details_span_Tag ContactIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                        {option.first_name.slice(0, 1).toUpperCase()}
                                    </span>
                                }</div>
                            <div>
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.first_name} ${option.last_name}`}</p>
                                <p style={{ margin: 0 }}>{option.email}</p>
                            </div>
                        </div>
                    </Option>))
                setContact(options)
                form.setFieldsValue({
                    contact: undefined,
                })
                setItems([])
                // setDisableFileds(true)
            }
            else {
                // setDisableFileds(false)
                setContact([])
                form.setFieldsValue({
                    contact: undefined,
                })
            }
        } catch (error) {
            message.error(error);
        }
        try {
            if (value) {
                const response = await FetchDealDetails(value);
                setDealDiscount(response?.data?.discount_percentage ? response?.data?.discount_percentage : 0)
                setDealType({
                    type: response?.data?.subtype,
                    product: response?.data?.products,
                    service: response?.data?.service
                })
                if (response?.data?.subtype === "Others") {
                    const DealValue = response?.data?.deal_value ? await ExchangeCurrency(Number(response?.data?.deal_value), ConvertRates) : response?.data?.deal_value;
                    const revenueStartDate = response?.data?.revenue_start_date !== "" && response?.data?.revenue_start_date !== null ? response?.data?.revenue_start_date : null;
                    const revenueEndDate = response?.data?.revenue_end_date !== "" && response?.data?.revenue_end_date !== null ? response?.data?.revenue_end_date : null;
                    setItems([{
                        ItemId: value,
                        name: "Others",
                        type: "Others",
                        value: DealValue,
                        startDate: revenueStartDate,
                        endDate: revenueEndDate,
                        total: DealValue
                    }])
                    setProductColumns([
                        {
                            title: 'Name',
                            dataIndex: 'name',
                            key: 'name',
                            render: (text, record) => (
                                <Form.Item>
                                    <Input
                                        // disabled={disableFileds}
                                        disabled
                                        name="name"
                                        value={record.name}
                                        placeholder="Name" />
                                </Form.Item>
                            ),
                        },
                        {
                            title: 'Type',
                            dataIndex: 'type',
                            key: 'type',
                            render: (text, record) => (
                                <Form.Item style={{ margin: 0, maxWidth: '225px', minWidth: '225px' }}>
                                    <Select getPopupContainer={getFieldPopupContainer}
                                        // disabled={disableFileds}
                                        disabled
                                        placeholder="Type"
                                        name="type"
                                        value={record.type}
                                    >
                                        <Option value="Product">Product</Option>
                                        <Option value="Service">Service</Option>
                                        <Option value="Staff Role">Staff Role</Option>
                                        <Option value="RFP">RFP</Option>
                                        <Option value="Others">Others</Option>
                                    </Select>
                                </Form.Item>
                            ),
                        },
                        {
                            title: `Price (${defaultCurrency?.currency})`,
                            dataIndex: 'value',
                            key: 'value',
                            render: (text, record) => (
                                <Form.Item>
                                    <Input type="text"
                                        // disabled={disableFileds}
                                        disabled
                                        prefix={defaultCurrency?.symbol}
                                        name="value"
                                        value={record.value}
                                        placeholder="Total" />
                                </Form.Item>
                            ),
                        },
                        {
                            title: 'Start Date',
                            dataIndex: 'startDate',
                            key: 'startDate',
                            type: 'date',
                            render: (text, record) => (
                                <Form.Item>
                                    <DatePicker
                                        // disabled={disableFileds}
                                        disabled
                                        format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                        value={record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null}
                                        name="startDate"
                                        disabledDate={disabledDate}
                                        placeholder="Start Date"
                                    />
                                </Form.Item>
                            ),
                        },
                        {
                            title: 'End Date',
                            dataIndex: 'endDate',
                            key: 'endDate',
                            type: 'date',
                            render: (text, record) => (
                                <Form.Item>
                                    <DatePicker
                                        // disabled={disableFileds}
                                        disabled
                                        format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                        value={record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null}
                                        name="endDate"
                                        disabledDate={disabledDate}
                                        placeholder="End Date"
                                    />
                                </Form.Item>
                            ),
                        },
                        {
                            title: `Total (${defaultCurrency?.currency})`,
                            dataIndex: 'total',
                            key: 'total',
                            render: (text, record,) => (
                                <Form.Item>
                                    <Input type="text" disabled prefix={defaultCurrency?.symbol}
                                        name="total"
                                        value={record.total}
                                        placeholder="Total" />
                                </Form.Item>
                            ),
                        },
                    ])
                }
                else if (response?.data?.subtype === "Staff Augmentation") {
                    const roleValues = response?.data?.staffRoles
                    const convertedRoleData = await Promise.all(
                        roleValues.map(async (role) => {
                            const convertedRate = await (role.role_per_day_rate !== undefined && role.role_per_day_rate !== null && role.role_per_day_rate !== ""
                                ? ExchangeCurrency(Number(role.role_per_day_rate), ConvertRates)
                                : role.role_per_day_rate);
                            const convertedTotalValue = await (role.total_value !== undefined && role.total_value !== null && role.total_value !== ""
                                ? ExchangeCurrency(Number(role.total_value), ConvertRates)
                                : role.total_value);
                            return {
                                ItemId: role.add_staff_role_id,
                                name: role.roleName,
                                country: role.country,
                                type: "Staff Role",
                                value: Number(convertedRate?.toFixed(CurencyDecimalPlace)),
                                startDate: role.start_date,
                                endDate: role.end_date,
                                total: Number(convertedTotalValue?.toFixed(CurencyDecimalPlace)),
                            };
                        })
                    );
                    setItems(convertedRoleData)
                    setProductColumns([
                        {
                            title: 'Name',
                            dataIndex: 'name',
                            key: 'name',
                            render: (text, record) => (
                                <Form.Item>
                                    <Input
                                        // disabled={disableFileds}
                                        disabled
                                        name="name"
                                        value={`${record.name}, ${record.country}`}
                                        placeholder="Name"
                                    />
                                </Form.Item>
                            ),
                        },
                        {
                            title: 'Type',
                            dataIndex: 'type',
                            key: 'type',
                            render: (text, record) => (
                                <Form.Item style={{ margin: 0, maxWidth: '225px', minWidth: '225px' }}>
                                    <Select getPopupContainer={getFieldPopupContainer}
                                        // disabled={disableFileds}
                                        disabled
                                        placeholder="Type"
                                        name="type"
                                        value={record.type}
                                    >
                                        <Option value="Product">Product</Option>
                                        <Option value="Service">Service</Option>
                                        <Option value="Staff Role">Staff Role</Option>
                                        <Option value="RFP">RFP</Option>
                                        <Option value="Others">Others</Option>
                                    </Select>
                                </Form.Item>
                            ),
                        },
                        {
                            title: `Price (${defaultCurrency?.currency})`,
                            dataIndex: 'value',
                            key: 'value',
                            render: (text, record) => (
                                <Form.Item>
                                    <Input type="text"
                                        // disabled={disableFileds}
                                        disabled
                                        prefix={defaultCurrency?.symbol}
                                        name="value"
                                        value={record.value}
                                        placeholder="Total" />
                                </Form.Item>
                            ),
                        },
                        {
                            title: 'Start Date',
                            dataIndex: 'startDate',
                            key: 'startDate',
                            type: 'date',
                            render: (text, record) => (
                                <Form.Item>
                                    <DatePicker
                                        // disabled={disableFileds}
                                        disabled
                                        format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                        value={record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null}
                                        name="startDate"
                                        disabledDate={disabledDate}
                                        placeholder="Start Date"
                                    />
                                </Form.Item>
                            ),
                        },
                        {
                            title: 'End Date',
                            dataIndex: 'endDate',
                            key: 'endDate',
                            type: 'date',
                            render: (text, record) => (
                                <Form.Item>
                                    <DatePicker
                                        // disabled={disableFileds}
                                        disabled
                                        format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                        value={record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null}
                                        name="endDate"
                                        disabledDate={disabledDate}
                                        placeholder="End Date"
                                    />
                                </Form.Item>
                            ),
                        },
                        {
                            title: `Total (${defaultCurrency?.currency})`,
                            dataIndex: 'total',
                            key: 'total',
                            render: (text, record) => (
                                <Form.Item>
                                    <Input type="text" disabled prefix={defaultCurrency?.symbol}
                                        name="total"
                                        value={record.total}
                                        placeholder="Total" />
                                </Form.Item>
                            ),
                        },
                    ])
                }
                else if (response?.data?.subtype === "Request for Proposal" || response?.data?.subtype === "Product and Services") {
                    if (response?.data?.products?.length === 0 && response?.data?.service?.length === 0 && response?.data?.subtype === "Request for Proposal") {
                        const DealValue = response?.data?.deal_value ? await ExchangeCurrency(Number(response?.data?.deal_value), ConvertRates) : response?.data?.deal_value;
                        const revenueStartDate = response?.data?.revenue_start_date !== "" && response?.data?.revenue_start_date !== null ? response?.data?.revenue_start_date : null;
                        const revenueEndDate = response?.data?.revenue_end_date !== "" && response?.data?.revenue_end_date !== null ? response?.data?.revenue_end_date : null;
                        setItems([{
                            ItemId: value,
                            name: "RFP",
                            type: "RFP",
                            value: DealValue,
                            startDate: revenueStartDate,
                            endDate: revenueEndDate,
                            total: DealValue
                        }])
                        setProductColumns([
                            {
                                title: 'Name',
                                dataIndex: 'name',
                                key: 'name',
                                render: (text, record) => (
                                    <Form.Item>
                                        <Input
                                            // disabled={disableFileds}
                                            disabled
                                            name="name"
                                            value={record.name}
                                            placeholder="Name" />
                                    </Form.Item>
                                ),
                            },
                            {
                                title: 'Type',
                                dataIndex: 'type',
                                key: 'type',
                                render: (text, record) => (
                                    <Form.Item style={{ margin: 0, maxWidth: '225px', minWidth: '225px' }}>
                                        <Select getPopupContainer={getFieldPopupContainer}
                                            // disabled={disableFileds}
                                            disabled
                                            placeholder="Type"
                                            name="type"
                                            value={record.type}
                                        >
                                            <Option value="Product">Product</Option>
                                            <Option value="Service">Service</Option>
                                            <Option value="Staff Role">Staff Role</Option>
                                            <Option value="RFP">RFP</Option>
                                            <Option value="Others">Others</Option>
                                        </Select>
                                    </Form.Item>
                                ),
                            },
                            {
                                title: `Price (${defaultCurrency?.currency})`,
                                dataIndex: 'value',
                                key: 'value',
                                render: (text, record) => (
                                    <Form.Item>
                                        <Input type="text"
                                            // disabled={disableFileds}
                                            disabled
                                            prefix={defaultCurrency?.symbol}
                                            name="value"
                                            value={record.value}
                                            placeholder="Total" />
                                    </Form.Item>
                                ),
                            },
                            {
                                title: 'Start Date',
                                dataIndex: 'startDate',
                                key: 'startDate',
                                type: 'date',
                                render: (text, record) => (
                                    <Form.Item>
                                        <DatePicker
                                            // disabled={disableFileds}
                                            disabled
                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                            value={record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null}
                                            name="startDate"
                                            disabledDate={disabledDate}
                                            placeholder="Start Date"
                                        />
                                    </Form.Item>
                                ),
                            },
                            {
                                title: 'End Date',
                                dataIndex: 'endDate',
                                key: 'endDate',
                                type: 'date',
                                render: (text, record) => (
                                    <Form.Item>
                                        <DatePicker
                                            // disabled={disableFileds}
                                            disabled
                                            format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                            value={record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null}
                                            name="endDate"
                                            disabledDate={disabledDate}
                                            placeholder="End Date"
                                        />
                                    </Form.Item>
                                ),
                            },
                            {
                                title: `Total (${defaultCurrency?.currency})`,
                                dataIndex: 'total',
                                key: 'total',
                                render: (text, record,) => (
                                    <Form.Item>
                                        <Input type="text" disabled prefix={defaultCurrency?.symbol}
                                            name="total"
                                            value={record.total}
                                            placeholder="Total" />
                                    </Form.Item>
                                ),
                            },
                        ])
                    }
                    else if (response?.data?.products?.length > 0 || response?.data?.service?.length > 0) {
                        const revenueStartDate = response?.data?.revenue_start_date !== "" && response?.data?.revenue_start_date !== null ? response?.data?.revenue_start_date : null;
                        const revenueEndDate = response?.data?.revenue_end_date !== "" && response?.data?.revenue_end_date !== null ? response?.data?.revenue_end_date : null;
                        if (response?.data?.products?.length > 0 && response?.data?.service?.length === 0) {
                            const convertedFormDatas = await Promise.all(
                                response?.data?.products.map(async (product) => {
                                    const convertedPrice = await (product.product_license_selling_price_unitMonth !== undefined && product.product_license_selling_price_unitMonth !== '' && product.product_license_selling_price_unitMonth !== null
                                        ? ExchangeCurrency(Number(product.product_license_selling_price_unitMonth), ConvertRates)
                                        : product.product_license_selling_price_unitMonth);
                                    const convertedTotal = await (product.total !== undefined && product.total !== '' && product.total !== null
                                        ? ExchangeCurrency(Number(product.total), ConvertRates)
                                        : 0);
                                    return {
                                        ItemId: product.deal_product_id,
                                        name: product.product_name,
                                        productCategory: product.product_category,
                                        type: "Product",
                                        value: Number(convertedPrice?.toFixed(CurencyDecimalPlace)),
                                        qty: product.number_of_units,
                                        duration: product.license_duration,
                                        total: Number(convertedTotal?.toFixed(CurencyDecimalPlace)),
                                    };
                                })
                            );
                            setItems(convertedFormDatas)
                            setProductColumns([
                                {
                                    title: 'Name',
                                    dataIndex: 'name',
                                    key: 'name',
                                    render: (text, record) => (
                                        <Form.Item>
                                            <Input
                                                name="name"
                                                // disabled={disableFileds}
                                                disabled
                                                value={record.name}
                                                placeholder="Name"
                                            />
                                        </Form.Item>
                                    ),
                                },
                                {
                                    title: 'Type',
                                    dataIndex: 'type',
                                    key: 'type',
                                    render: (text, record) => (
                                        <Form.Item style={{ margin: 0, maxWidth: '225px', minWidth: '225px' }}>
                                            <Select getPopupContainer={getFieldPopupContainer}
                                                placeholder="Type"
                                                name="type"
                                                value={record.type}
                                                // disabled={disableFileds}
                                                disabled
                                            >
                                                <Option value="Product">Product</Option>
                                                <Option value="Service">Service</Option>
                                                <Option value="Staff Role">Staff Role</Option>
                                                <Option value="RFP">RFP</Option>
                                                <Option value="Others">Others</Option>
                                            </Select>
                                        </Form.Item>
                                    ),
                                },
                                {
                                    title: `Price (${defaultCurrency?.currency})`,
                                    dataIndex: 'value',
                                    key: 'value',
                                    render: (text, record) => (
                                        <Form.Item>
                                            <Input type="text"
                                                // disabled={disableFileds}
                                                disabled
                                                prefix={defaultCurrency?.symbol}
                                                name="value"
                                                value={record.value}
                                                placeholder="Total" />
                                        </Form.Item>
                                    ),
                                },
                                {
                                    title: 'Quantity',
                                    dataIndex: 'qty',
                                    key: 'qty',
                                    render: (text, record) => (
                                        <Form.Item>
                                            <Input pattern="^\d+$" min={0}
                                                name="qty"
                                                // disabled={disableFileds}
                                                disabled
                                                value={record.qty}
                                                placeholder="Number of Units" />
                                        </Form.Item>
                                    ),
                                },
                                {
                                    title: (<div>Duration  <InfoCircleOutlined style={{ color: '#0000009c', cursor: 'pointer', margin: "0px" }} title="Months" /></div>),
                                    dataIndex: 'duration',
                                    key: 'duration',
                                    render: (text, record,) => (
                                        <Form.Item>
                                            <Input pattern="^\d+$" min={0}
                                                // disabled={disableFileds}
                                                disabled
                                                name="duration"
                                                value={record.productCategory !== "Software" ? "One off" : record.duration}
                                                placeholder="License Duration" />
                                        </Form.Item>
                                    ),
                                },
                                {
                                    title: `Total (${defaultCurrency?.currency})`,
                                    dataIndex: 'total',
                                    key: 'total',
                                    render: (text, record,) => (
                                        <Form.Item>
                                            <Input type="text" disabled prefix={defaultCurrency?.symbol}
                                                name="total"
                                                value={record.total}
                                                placeholder="Total" />
                                        </Form.Item>
                                    ),
                                },
                            ])
                        }
                        if (response?.data?.products?.length === 0 && response?.data?.service?.length > 0) {
                            const convertedServicesData = await Promise.all(
                                response?.data?.service.map(async (service) => {
                                    const convertedCost = await (service.service_line_cost !== undefined && service.service_line_cost !== null && service.service_line_cost !== "" ?
                                        ExchangeCurrency(Number(service.service_line_cost), ConvertRates)
                                        : service.service_line_cost
                                    );
                                    return {
                                        ItemId: service.service_line_id,
                                        name: service.service_name,
                                        type: "Service",
                                        value: Number(convertedCost?.toFixed(CurencyDecimalPlace)),
                                        startDate: revenueStartDate,
                                        endDate: revenueEndDate,
                                        total: Number(convertedCost?.toFixed(CurencyDecimalPlace)),
                                    };
                                })
                            );
                            setItems(convertedServicesData)
                            setProductColumns([
                                {
                                    title: 'Name',
                                    dataIndex: 'name',
                                    key: 'name',
                                    render: (text, record) => (
                                        <Form.Item>
                                            <Input
                                                name="name"
                                                // disabled={disableFileds}
                                                disabled
                                                value={record.name}
                                                placeholder="Name" />
                                        </Form.Item>
                                    ),
                                },
                                {
                                    title: 'Type',
                                    dataIndex: 'type',
                                    key: 'type',
                                    render: (text, record) => (
                                        <Form.Item style={{ margin: 0, maxWidth: '225px', minWidth: '225px' }}>
                                            <Select getPopupContainer={getFieldPopupContainer}
                                                placeholder="Type"
                                                name="type"
                                                // disabled={disableFileds}
                                                disabled
                                                value={record.type}
                                            >
                                                <Option value="Product">Product</Option>
                                                <Option value="Service">Service</Option>
                                                <Option value="Staff Role">Staff Role</Option>
                                                <Option value="RFP">RFP</Option>
                                                <Option value="Others">Others</Option>
                                            </Select>
                                        </Form.Item>
                                    ),
                                },
                                {
                                    title: `Price (${defaultCurrency?.currency})`,
                                    dataIndex: 'value',
                                    key: 'value',
                                    render: (text, record) => (
                                        <Form.Item>
                                            <Input type="text"
                                                // disabled={disableFileds}
                                                disabled
                                                prefix={defaultCurrency?.symbol}
                                                name="value"
                                                value={record.value}
                                                placeholder="Total" />
                                        </Form.Item>
                                    ),
                                },
                                {
                                    title: 'Start Date',
                                    dataIndex: 'startDate',
                                    key: 'startDate',
                                    type: 'date',
                                    render: (text, record) => (
                                        <Form.Item>
                                            <DatePicker
                                                // disabled={disableFileds}
                                                disabled
                                                format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                value={record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null}
                                                name="startDate"
                                                disabledDate={disabledDate}
                                                placeholder="Start Date"
                                            />
                                        </Form.Item>
                                    ),
                                },
                                {
                                    title: 'End Date',
                                    dataIndex: 'endDate',
                                    key: 'endDate',
                                    type: 'date',
                                    render: (text, record) => (
                                        <Form.Item>
                                            <DatePicker
                                                // disabled={disableFileds}
                                                disabled
                                                format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                value={record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null}
                                                name="endDate"
                                                disabledDate={disabledDate}
                                                placeholder="End Date"
                                            />
                                        </Form.Item>
                                    ),
                                },
                                {
                                    title: `Total (${defaultCurrency?.currency})`,
                                    dataIndex: 'total',
                                    key: 'total',
                                    render: (text, record,) => (
                                        <Form.Item>
                                            <Input type="text" disabled prefix={defaultCurrency?.symbol}
                                                name="total"
                                                value={record.total}
                                                placeholder="Total" />
                                        </Form.Item>
                                    ),
                                },
                            ])
                        }
                        if (response?.data?.products?.length > 0 && response?.data?.service?.length > 0) {
                            let productData = [];
                            let serviceData = [];
                            productData = await Promise.all(
                                response?.data?.products.map(async (product) => {
                                    const convertedPrice = await (product.product_license_selling_price_unitMonth !== undefined && product.product_license_selling_price_unitMonth !== '' && product.product_license_selling_price_unitMonth !== null
                                        ? ExchangeCurrency(Number(product.product_license_selling_price_unitMonth), ConvertRates)
                                        : product.product_license_selling_price_unitMonth);
                                    const convertedTotal = await (product.total !== undefined && product.total !== '' && product.total !== null
                                        ? ExchangeCurrency(Number(product.total), ConvertRates)
                                        : 0);
                                    return {
                                        ItemId: product.deal_product_id,
                                        name: product.product_name,
                                        productCategory: product.product_category,
                                        type: "Product",
                                        value: Number(convertedPrice?.toFixed(CurencyDecimalPlace)),
                                        qty: product.number_of_units,
                                        duration: product.license_duration,
                                        total: Number(convertedTotal?.toFixed(CurencyDecimalPlace)),
                                    };
                                })
                            );
                            serviceData = await Promise.all(
                                response?.data?.service.map(async (service) => {
                                    const convertedCost = await (service.service_line_cost !== undefined && service.service_line_cost !== null && service.service_line_cost !== "" ?
                                        ExchangeCurrency(Number(service.service_line_cost), ConvertRates)
                                        : service.service_line_cost
                                    );
                                    return {
                                        ItemId: service.service_line_id,
                                        name: service.service_name,
                                        type: "Service",
                                        value: Number(convertedCost?.toFixed(CurencyDecimalPlace)),
                                        startDate: revenueStartDate,
                                        endDate: revenueEndDate,
                                        total: Number(convertedCost?.toFixed(CurencyDecimalPlace)),
                                    };
                                })
                            );
                            const combineData = [...productData, ...serviceData];
                            setItems(combineData)
                            setProductColumns([
                                {
                                    title: 'Name',
                                    dataIndex: 'name',
                                    key: 'name',
                                    render: (text, record) => (
                                        <Form.Item>
                                            <Input
                                                name="name"
                                                // disabled={disableFileds}
                                                disabled
                                                value={record.name}
                                                placeholder="Name"
                                            />
                                        </Form.Item>
                                    ),
                                },
                                {
                                    title: 'Type',
                                    dataIndex: 'type',
                                    key: 'type',
                                    render: (text, record) => (
                                        <Form.Item style={{ margin: 0, maxWidth: '225px', minWidth: '225px' }}>
                                            <Select getPopupContainer={getFieldPopupContainer}
                                                placeholder="Type"
                                                name="type"
                                                // disabled={disableFileds}
                                                disabled
                                                value={record.type}
                                            >
                                                <Option value="Product">Product</Option>
                                                <Option value="Service">Service</Option>
                                                <Option value="Staff Role">Staff Role</Option>
                                                <Option value="RFP">RFP</Option>
                                                <Option value="Others">Others</Option>
                                            </Select>
                                        </Form.Item>
                                    ),
                                },
                                {
                                    title: `Price (${defaultCurrency?.currency})`,
                                    dataIndex: 'value',
                                    key: 'value',
                                    render: (text, record) => (
                                        <Form.Item>
                                            <Input type="text"
                                                // disabled={disableFileds}
                                                disabled
                                                prefix={defaultCurrency?.symbol}
                                                name="value"
                                                value={record.value}
                                                placeholder="Total" />
                                        </Form.Item>
                                    ),
                                },
                                {
                                    title: 'Quantity',
                                    dataIndex: 'qty',
                                    key: 'qty',
                                    render: (text, record) => (
                                        <Form.Item>
                                            <Input pattern="^\d+$" min={0}
                                                name="qty"
                                                // disabled={disableFileds}
                                                disabled
                                                value={record.qty}
                                                placeholder="Quantity" />
                                        </Form.Item>
                                    ),
                                },
                                {
                                    title: (<div>Duration  <InfoCircleOutlined style={{ color: '#0000009c', cursor: 'pointer', margin: "0px" }} title="Months" /></div>),
                                    dataIndex: 'duration',
                                    key: 'duration',
                                    render: (text, record,) => (
                                        <Form.Item>
                                            <Input pattern='^\d+$ ' min={0}
                                                name="duration"
                                                // disabled={disableFileds}
                                                disabled
                                                value={record.productCategory !== "Software" ? "One off" : record.duration}
                                                placeholder="License Duration" />
                                        </Form.Item>
                                    ),
                                },
                                {
                                    title: 'Start Date',
                                    dataIndex: 'startDate',
                                    key: 'startDate',
                                    type: 'date',
                                    render: (text, record) => (
                                        <Form.Item>
                                            <DatePicker
                                                // disabled={disableFileds}
                                                disabled
                                                format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                value={record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null}
                                                name="startDate"
                                                disabledDate={disabledDate}
                                                placeholder="Start Date"
                                            />
                                        </Form.Item>
                                    ),
                                },
                                {
                                    title: 'End Date',
                                    dataIndex: 'endDate',
                                    key: 'endDate',
                                    type: 'date',
                                    render: (text, record) => (
                                        <Form.Item>
                                            <DatePicker
                                                format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                value={record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null}
                                                name="endDate"
                                                // disabled={disableFileds}
                                                disabled
                                                disabledDate={disabledDate}
                                                placeholder="End Date"
                                            />
                                        </Form.Item>
                                    ),
                                },
                                {
                                    title: `Total (${defaultCurrency?.currency})`,
                                    dataIndex: 'Total',
                                    key: 'total',
                                    render: (text, record,) => (
                                        <Form.Item>
                                            <Input type="text" disabled prefix={defaultCurrency?.symbol}
                                                name="total"
                                                value={record.total}
                                                placeholder="Total" />
                                        </Form.Item>
                                    ),
                                },
                            ])
                        }
                    }
                }
            }
            else {
                setDealType()
                setDealDiscount()
                setItems([])
                setProductColumns([
                    {
                        title: 'Name',
                        dataIndex: 'Name',
                        key: 'Name',
                    },
                    {
                        title: 'Type',
                        dataIndex: 'Type',
                        key: 'Type',
                    },
                    {
                        title: `Price (${defaultCurrency?.currency})`,
                        dataIndex: 'Price',
                        key: 'Price',
                    },
                    {
                        title: 'Quantity',
                        dataIndex: 'Quantity',
                        key: 'Quantity',
                    },
                    {
                        title: 'Start Date',
                        dataIndex: 'StartDate',
                        key: 'StartDate',
                    },
                    {
                        title: 'End Date',
                        dataIndex: 'EndDate',
                        key: 'EndDate',
                    },
                    {
                        title: (<div>Duration  <InfoCircleOutlined style={{ color: '#0000009c', cursor: 'pointer', margin: "0px" }} title="Months" /></div>),
                        dataIndex: 'Duration',
                        key: 'Duration',
                    },
                    {
                        title: `Total (${defaultCurrency?.currency})`,
                        dataIndex: 'Total',
                        key: 'Total',
                    },
                ])
            }
        } catch (error) {
            message.error(error);
        }
    }
    async function onChangeContact(value) {
        form.setFieldsValue({ contact: value || null })
        try {
            if (value) {
                const response = await FetchContactDetails(value);
                setBillingAddress({
                    name: billingAddress?.name,
                    country: billingAddress?.country,
                    city: billingAddress?.city,
                    state: billingAddress?.state,
                    street: billingAddress?.street,
                    zipcode: billingAddress?.zipcode,
                    email: response?.data?.email,
                    mobile: response?.data?.mobile
                })
                setShipingAddress({
                    name: shipingAddress?.name,
                    country: shipingAddress?.country,
                    city: shipingAddress?.city,
                    state: shipingAddress?.state,
                    street: shipingAddress?.street,
                    zipcode: shipingAddress?.zipcode,
                    email: response?.data?.email,
                    mobile: response?.data?.mobile
                })
            }
            else {
                setBillingAddress({
                    name: billingAddress?.name,
                    country: billingAddress?.country,
                    city: billingAddress?.city,
                    state: billingAddress?.state,
                    street: billingAddress?.street,
                    zipcode: billingAddress?.zipcode,
                    email: undefined,
                    mobile: undefined
                })
                setShipingAddress({
                    name: shipingAddress?.name,
                    country: shipingAddress?.country,
                    city: shipingAddress?.city,
                    state: shipingAddress?.state,
                    street: shipingAddress?.street,
                    zipcode: shipingAddress?.zipcode,
                    email: undefined,
                    mobile: undefined
                })
            }
        } catch (error) {
            message.error(error);
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            const options = data.filter(item => item.department === "Sales").map((option, i) => (
                <Option value={option.userId} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                    < img src={option.profilePic} alt="profile" />
                                    :
                                    <span className="image_icon UserIcon">
                                        {option.firstName.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                            </div>
                        </div>
                    </div>
                    // <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    //     {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                    //         < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                    //         :
                    //         <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                    //             {option.firstName.slice(0, 1).toUpperCase()}
                    //         </span>
                    //     }
                    //     <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                    // </div>
                )}>
                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                        <div>
                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.firstName.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                            <p style={{ margin: 0 }}>{option.username}</p>
                        </div>
                    </div>
                </Option>));
            setUsers(options)
        } catch (error) {
            message.error(error);
        }
    }
    async function AccountApi() {
        try {
            const data = await FetchAllAccount()
            let accountInfo = data
            if (displayData?.accountId) {
                const isAlreadyIncluded = data?.some(contact => contact.account_id === displayData?.accountId);
                if (!isAlreadyIncluded) {
                    accountInfo = [...accountInfo, { account_name: displayData?.accountName, account_number: displayData?.accountNumber, account_id: displayData?.accountId, account_type_name: "Customer" }];
                }
            }
            if (FromPage === "FromDeal" && dataForDeal) {
                const isAlreadyIncluded = data?.some(contact => contact.account_id === dataForDeal?.dealDetails?.account_id);
                if (!isAlreadyIncluded) {
                    accountInfo = [...accountInfo, { account_name: dataForDeal?.dealDetails?.account_name, account_id: dataForDeal?.dealDetails?.account_id, account_type_name: "Customer", account_number: dataForDeal?.dealDetails?.account_number, account_profile: dataForDeal?.dealDetails?.account_profile }];
                }
            }
            const options = accountInfo.filter((item) => item.account_type_name === "Customer").map((option, i) => (
                <Option value={option.account_id} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.account_name} (${option.account_number})`} style={{ cursor: "default" }}>
                                {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                    < img src={option.account_profile} alt="profile" />
                                    :
                                    <span className="image_icon AccountIcon">
                                        {option.account_name.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{option.account_name}</span>
                            </div>
                        </div>
                    </div>)}>
                    <div className='UserList-dropdown' title={`${option.account_name} (${option.account_number})`}>
                        <div>
                            {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.account_name.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                            <p style={{ margin: 0 }}>{option.account_number}</p>
                        </div>
                    </div>
                </Option>));
            setAccount(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function ConnectwithDeal(quotesData) {
        let hideMessage;
        try {
            hideMessage = message.loading("Sync with deal...", 0);
            const dealArray = await getDealsyncData(quotesData?.dealId, profile, disabledDate, defaultCurrency, ConvertRates, CurencyDecimalPlace)
            setDealDiscount(dealArray?.discount)
            setDealType(dealArray?.datas)
            setItems(dealArray?.items)
            setProductColumns(dealArray?.columns)
            hideMessage();
            message.success("Quotes updated with current deal details");
        } catch (error) {
            message.error("Failed to sync with current deal");
            hideMessage();
        }
    }
    // const removeTableItems = async (index) => {
    //     const updatedFormData = [...items];
    //     updatedFormData.splice(index, 1);
    //     setItems(updatedFormData);
    // };
    // const handleTableItem = async (index, fieldName, value) => {
    //     const updatedFormData = [...items];
    //     if (fieldName === "startDate" || fieldName === "endDate") {
    //         const date = RequiredDateFormating(value)
    //         updatedFormData[index] = {
    //             ...updatedFormData[index],
    //             [fieldName]: date,
    //         };
    //     }
    //     else {
    //         updatedFormData[index] = {
    //             ...updatedFormData[index],
    //             [fieldName]: value,
    //         };
    //     }
    //     const Cost = parseFloat(updatedFormData[index].value || 0);
    //     const Duration = parseFloat(updatedFormData[index].duration || 0);
    //     const SDate = updatedFormData[index].startDate;
    //     const EDate = updatedFormData[index].endDate;
    //     const Qty = parseFloat(updatedFormData[index].qty || 0);

    //     let totalBusinessDays = 0;
    //     if (SDate && EDate) {
    //         totalBusinessDays = await getDaysBetween(SDate, EDate)
    //     }
    //     if (Cost > 0 && Qty > 0) {
    //         if (Duration > 0) {
    //             updatedFormData[index].total = Cost * Qty * Duration
    //         }
    //         else if (totalBusinessDays > 0) {
    //             updatedFormData[index].total = Cost * Qty * totalBusinessDays
    //         }
    //         else {
    //             updatedFormData[index].total = Cost * Qty
    //         }
    //     }
    //     setItems(updatedFormData);
    // };
    // async function AddTableItems() {
    //     setItems([...items, {
    //         name: null,
    //         type: null,
    //         value: null,
    //         qty: "",
    //         duration: "",
    //         startDate: null,
    //         endDate: null,
    //         total: null,
    //     }]);
    // }
    // const editableColumns = [
    //     {
    //         title: 'Name',
    //         dataIndex: 'name',
    //         key: 'name',
    //         render: (text, record, index) => (
    //             <Form.Item>
    //                 {/* {edit ? */}
    //                 <Input
    //                     name="name"
    //                     value={record.name}
    //                     placeholder="Name"
    //                     onChange={(e) => {
    //                         handleTableItem(index, 'name', e.target.value);
    //                     }}
    //                 />
    //                 {/* : <span >
    //                             {displayData?.products[index]?.name}
    //                         </span>} */}
    //             </Form.Item>
    //         ),
    //     },
    //     {
    //         title: 'Type',
    //         dataIndex: 'type',
    //         key: 'type',
    //         render: (text, record, index) => (
    //             <Form.Item style={{ margin: 0, maxWidth: '225px', minWidth: '225px' }}>
    //                 <Select  getPopupContainer={getFieldPopupContainer}
    //                     placeholder="Type"
    //                     name="type"
    //                     value={record.type}
    //                     onChange={(value) => {
    //                         handleTableItem(index, 'type', value);
    //                     }}
    //                 >
    //                     <Option value="Product">Product</Option>
    //                     <Option value="Service">Service</Option>
    //                     <Option value="Staff Role">Staff Role</Option>
    //                     <Option value="RFP">RFP</Option>
    //                     <Option value="Others">Others</Option>
    //                 </Select>
    //             </Form.Item>
    //         ),
    //     },
    //     {
    //         title: `Price (${defaultCurrency?.currency})`,
    //         dataIndex: 'value',
    //         key: 'value',
    //         render: (text, record, index) => (
    //             <Form.Item>
    //                 {/* {edit ?  */}
    //                 <Input type="text"
    //                     prefix={defaultCurrency?.symbol}
    //                     name="value"
    //                     value={record.value}
    //                     onChange={(e) => {
    //                         handleTableItem(index, 'value', e.target.value);
    //                     }}
    //                     placeholder="Total" />
    //                 {/* // : <>{defaultCurrency?.symbol} <span >
    //                         //     {displayData?.products[index]?.value?.toLocaleString()}
    //                         // </span></>} */}
    //             </Form.Item>
    //         ),
    //     },
    //     {
    //         title: 'Quantity',
    //         dataIndex: 'qty',
    //         key: 'qty',
    //         render: (text, record, index) => (
    //             <Form.Item>
    //                 {/* {edit ?  */}
    //                 <Input type="number" min={0}
    //                     name="qty"
    //                     value={record.qty}
    //                     onChange={(e) => {
    //                         handleTableItem(index, 'qty', e.target.value);
    //                     }}
    //                     placeholder="Quantity" />
    //                 {/* // : <span >
    //                         //     {displayData?.products[index]?.qty}
    //                         // </span>} */}
    //             </Form.Item>
    //         ),
    //     },
    //     {
    //         title: (<div>Duration  <InfoCircleOutlined style={{ color: '#0000009c', cursor: 'pointer', margin: "0px" }} title="Months" /></div>),
    //         dataIndex: 'duration',
    //         key: 'duration',
    //         render: (text, record, index) => (
    //             <Form.Item>
    //                 {/* {edit ?  */}
    //                 <Input type="number" min={0}
    //                     name="duration" disabled={record.startDate || record.endDate}
    //                     value={record.duration}
    //                     onChange={(e) => {
    //                         handleTableItem(index, 'duration', e.target.value);
    //                     }}
    //                     placeholder="Duration" />
    //                 {/* : <span >
    //                             {displayData?.products[index]?.license_duration}
    //                         </span>} */}
    //             </Form.Item>
    //         ),
    //     },
    //     {
    //         title: 'Start Date',
    //         dataIndex: 'startDate',
    //         key: 'startDate',
    //         render: (text, record, index) => (
    //             <Form.Item>
    //                 {/* {edit ? */}
    //                 <DatePicker disabled={record?.duration && record.duration !== ""}
    //                     format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
    //                     value={record.startDate ? moment(record.startDate, "YYYY-MM-DD") : null}
    //                     name="startDate"
    //                     disabledDate={disabledDate}
    //                     placeholder="Start Date"
    //                     onChange={(date, dateString) =>
    //                         handleTableItem(index, 'startDate', dateString)
    //                     }
    //                 />
    //                 {/*  : // <span >
    //                         //     {displayData?.staffRoles[index]?.start_date ? moment(displayData?.staffRoles[index].start_date).format(profile.dateFormate) : (displayData?.staffRoles[index]?.start_date && moment(displayData?.staffRoles[index].start_date).format("YYYY-MM-DD"))}
    //                         // </span>} */}
    //             </Form.Item>
    //         ),
    //     },
    //     {
    //         title: 'End Date',
    //         dataIndex: 'endDate',
    //         key: 'endDate',
    //         render: (text, record, index) => (
    //             <Form.Item>
    //                 {/* {edit ? */}
    //                 <DatePicker
    //                     format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
    //                     value={record.endDate ? moment(record.endDate, "YYYY-MM-DD") : null}
    //                     name="endDate" disabled={record?.duration && record.duration !== ""}
    //                     disabledDate={disabledDate}
    //                     placeholder="End Date"
    //                     onChange={(date, dateString) =>
    //                         handleTableItem(index, 'endDate', dateString,)
    //                     }
    //                 />
    //                 {/*  : // <span >
    //                         //     {displayData?.staffRoles[index]?.start_date ? moment(displayData?.staffRoles[index].start_date).format(profile.dateFormate) : (displayData?.staffRoles[index]?.start_date && moment(displayData?.staffRoles[index].start_date).format("YYYY-MM-DD"))}
    //                         // </span>} */}
    //             </Form.Item>
    //         ),
    //     },
    //     {
    //         title: `Total (${defaultCurrency?.currency})`,
    //         dataIndex: 'Total',
    //         key: 'total',
    //         render: (text, record,) => (
    //             <Form.Item>
    //                 {/* {edit ?  */}
    //                 <Input type="text" disabled prefix={defaultCurrency?.symbol}
    //                     name="total"
    //                     value={record.total}
    //                     placeholder="Total" />
    //                 {/* : <>{defaultCurrency?.symbol} <span >
    //                             {displayData?.products[index]?.total?.toLocaleString()}
    //                         </span></>} */}
    //             </Form.Item>
    //         ),
    //     },
    //     {
    //         title: '',
    //         dataIndex: 'action',
    //         key: 'action',
    //         render: (text, record, index) => {
    //             if (edit && items.length > 0) {
    //                 return (
    //                     <FeatherIcon icon="trash-2" size={20} style={{ margin: "0px"}}   className="fetcherDelete-Icon"
    //                         onClick={() => removeTableItems(index)}
    //                     />
    //                 );
    //             }
    //         },
    //     },
    //     {
    //         title: '',
    //         dataIndex: 'addAction',
    //         key: 'addAction',
    //         render: (text, record, index) => {
    //             if (edit && index === items.length - 1) {
    //                 return (
    //                     <PlusCircleOutlined
    //                         title="Add Item"
    //                         style={{ color: "#407fe9", fontSize: 20, cursor: 'pointer', margin: "0px", }}
    //                         onClick={AddTableItems}
    //                     />
    //                 );
    //             }
    //         },
    //     }
    // ]
    const addressPopup = (type, content) => {
        setPopupOpen(true)
        setPopupType(type)
        setPopupContent(content)
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const dealrestartDateChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setValidDate(formattedDate);
    };
    const dealrestartDateChange2 = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setIssueDate(formattedDate);
    };
    const updateStatus1 = async (id) => {
        let hideMessage;
        try {
            hideMessage = message.loading("Updating status...", 0);
            const payload = {
                quotesStatus: "Delivered",
            }
            const response = await updateQuotes(payload, id)
            if (response.status === 200) {
                dispatch(setEditCall(false))
                getData(quotesId)
                scroolup()
                hideMessage();
            }
        }
        catch (error) {
            hideMessage();
            message.error(error);
        }
    }
    const updateStatus = (values) => {
        if (displayData?.quotesStatus !== "Delivered") {
            const modal = Modal.confirm({
                title: (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                        <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
                        <span> Change Status?</span>
                    </div>
                ),
                icon: null,
                content: (
                    <p>Would you like to update the status of this quote to Delivered?</p>
                ),
                className: "customice-confirm-modal",
                centered: true,
                okText: "Yes",
                cancelText: "No",
                okButtonProps: {
                    className: "button_colorsModal"
                },
                cancelButtonProps: {
                    className: "gray-buttonModal"
                },
                okCancel: true,
                onOk() {
                    updateStatus1(values)
                },
                onCancel() {
                    modal.destroy();
                },
            });
        }
    };
    const buildPdfFileName = (companyName, code, date) => {
        const clean = (s) => String(s ?? "").replace(/[\\/:*?"<>|]/g, "").replace(/\s+/g, " ").trim();
        const profileFormat = profile?.dateFormate || "YYYY-MM-DD";
        const parsed = date ? moment(date, [profileFormat, moment.ISO_8601], true) : null;
        const datePart = parsed && parsed.isValid() ? parsed.format("DDMMYYYY") : "";
        return [clean(companyName), clean(code), datePart].filter(Boolean).join("_");
    };
    const CreateMail = async () => {
        if (emailactiontype) {
            setPopupMessage(true)
        }
        else {
            const blob =
                await pdf(
                    <QuotationPdf data={displayData} profile={profile} accountJsonData={accountJsonData}
                        companyData={companyData} tableItem={items}
                        tableColum={ProductColumns} currencySettings={defaultCurrency}
                        Calculation={{ total, dealDiscount, tax, adjustment, shippingss, grandTotal }}
                        theme={pdfTheme}
                    />
                ).toBlob();
            const arrayBuffer = await blob.arrayBuffer();
            const buffer = {
                filename: `${buildPdfFileName(companyData?.registeredName ? companyData?.registeredName : companyData?.companyName, displayData?.quotesNumber, displayData?.validUntil)}.pdf`,
                contentType: "application/pdf",
                size: blob.size,
                contentDisposition: "attachment",
                content: {
                    type: "Buffer",
                    data: Array.from(new Uint8Array(arrayBuffer)),
                },
            };
            setAttachFile(buffer)
            setMailOpen(true)
        }
    }
    const closeMailComposr = () => {
        setMailOpen(false);
    };
    function extractTimeZoneName(tzString) {
        const parts = tzString.split(" ");
        return parts[1];
    }
    const fetchAll1 = async () => {
        await Promise.allSettled([
            scroolup(),
            GetSalesOrders(),
        ])
    }
    useEffect(() => {
        if (FromPage) {
            fetchAll1()
        }
    }, [FromPage])
    const fetchAll = async () => {
        await Promise.allSettled([
            getAccoutList(displayData),
            getAccountData(displayData?.accountId),
            getDealList(displayData),
            UserDetailsApi(),
            AccountApi(),
        ])
        setUiReady(true)
    };
    const fetchAll2 = async (data) => {
        await Promise.allSettled([
            getDealData(data),
            getAccountData(data?.AccountId),
        ])
    };
    useEffect(() => {
        if (FromPage && editField && displayData) {
            fetchAll()
        }
    }, [FromPage, editField, displayData])
    useEffect(() => {
        const currentUrlId = JSON.stringify(UrlId); // <-- serialize for comparison
        const currentFromPage = FromPage;
        if (
            prevValues.current.UrlId === currentUrlId &&
            prevValues.current.FromPage === currentFromPage
        ) {
            return;
        }
        prevValues.current = {
            UrlId: currentUrlId,
            FromPage: currentFromPage,
        };
        if (FromPage) {
            if (FromPage === "EntityUpdate") {
                getEntityAvalibitlity()
                getCompanyDetails()
                getList("Update")
            } else {
                if (FromPage === "FromDeal") {
                    fetchAll2(dataForDeal)
                    form.setFieldsValue({
                        status: "Draft",
                    })
                } else {
                    form.setFieldsValue({
                        subject: undefined,
                        number: undefined,
                        quoteOwner: undefined,
                        status: "Draft",
                        deal: undefined,
                        account: undefined,
                        contact: undefined,
                        date: undefined,
                        // description: undefined,
                        // termsandCondition: undefined
                    })
                    setContent1()
                    setContent2()
                    setAccountJsonData()
                }
                const getUserDetail = async () => {
                    const tzString = profile?.timeZone || "(GMT+0:00) UTC";
                    const tz = extractTimeZoneName(tzString);
                    const currentrealTime = moment().tz(tz).format("YYYY-MM-DD HH:mm")
                    const date = new Date(currentrealTime);
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, "0");
                    const day = String(date.getDate()).padStart(2, "0");
                    const localDate = `${year}-${month}-${day}`;
                    form.setFieldsValue({
                        isssueDate: moment(formatDateString(localDate, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"),
                    });
                    setIssueDate(localDate)
                    if (UrlId === undefined || UrlId === null) {
                        if (profile.department === "Sales") {
                            form.setFieldsValue({
                                quoteOwner: profile.userId
                            });
                        }
                    }
                }
                getUserDetail()
                setEdit(true)
                getList("Create")
                setDisplayData("Create")
                setQuotesId()
                setEditField(true)
            }
        }
    }, [UrlId, FromPage]);
    useEffect(() => {
        if (FromPage) {
            totalCalculation()
        }
    }, [items, dealDiscount, tax, adjustment, shippingss, FromPage])
    const matchingSalesOrder = salesOrderData.find(order => order.quoteId === quotesId);
    const handledownloadPdf = async () => {
        const blob = await pdf(
            <QuotationPdf data={displayData} profile={profile} accountJsonData={accountJsonData}
                companyData={companyData} tableItem={items}
                tableColum={ProductColumns} currencySettings={defaultCurrency}
                Calculation={{ total, dealDiscount, tax, adjustment, shippingss, grandTotal }}
                theme={pdfTheme}
            />
        ).toBlob();
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${buildPdfFileName(companyData?.registeredName ? companyData?.registeredName : companyData?.companyName, displayData?.quotesNumber, displayData?.validUntil)}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    // const content = (
    //     <div style={{
    //         width: "100%",
    //         height: "100%",
    //     }}>
    //         <span role="button" className="text_icon moreLinks"
    //             tabIndex={0}
    //             onClick={edit ? () => ConnectwithDeal(displayData) : undefined}
    //             onKeyDown={(event) => {
    //                 if (event.key === 'Enter' || event.key === ' ') {
    //                     ConnectwithDeal(displayData)
    //                 }
    //             }}>
    //             <QUSOINIcon height={16} width={16} marginRight={5} /> Sync with Deal
    //         </span>
    //     </div >
    // );
    const SaledOrderPage = () => {
        if (matchingSalesOrder) {
            dispatch(setReDirCall(null));
            ExcryptedNavigation("Nav", matchingSalesOrder.salesOrderId, "SORDER", history, dispatch, null, null)
        } else {
            setCratePageQuote("FromQuote")
            setDataForQuote({ QuoteId: quotesId })
        }
    }
    const SubjectData = `${companyData?.companyName} – Quotation for ${displayData?.quotesName}`;
    // const MailContent = `<div> </div>
    // <div contenteditable='false' style="margin: 20px 0px 0px"> 
    const MailContent = `
        <div><br></div>
    <div style="margin: 20px 0px 0px">
         <div>Dear ${displayData?.contactFirstName},</div>
         <div>&nbsp;</div>
         <div dir="auto">Thank you for considering ${companyData?.companyName} for your ${displayData?.quotesName} needs. Please find attached the quotation for your review.</div>
         <div>&nbsp;</div>
         <div>Quote Details:</div>
         <div>&bull; Quote Number: ${displayData?.quotesNumber}</div>
         <div>&bull; Quote Date: ${displayData?.issueDate ? moment(displayData?.issueDate).format(profile.dateFormate) :
            (displayData?.issueDate && moment(displayData?.issueDate).format("YYYY-MM-DD"))}</div>
         <div>&bull; Valid Until: ${displayData?.validUntil ? moment(displayData?.validUntil).format(profile.dateFormate) :
            (displayData?.validUntil && moment(displayData?.validUntil).format("YYYY-MM-DD"))}</div>
         <div>&bull; Total Amount: ${defaultCurrency?.symbol} ${Number(grandTotal)?.toLocaleString()}</div>
         <div>&nbsp;</div>
         <div>If you have any questions or need modifications, feel free to reach out. We look forward to your confirmation and the opportunity to serve you.</div>
         <div>&nbsp;</div>
         <div id = "signature-block-unique" contenteditable = "true" style = "margin-top: 20px;" >
            ${profile?.profileSignature || "<div>Add signature</div>"}
         </div >
         <div>&nbsp;</div>
         </div > `;
    const handleEditChange = () => {
        setEditField(true)
        setEdit(true)
        dispatch(setEditCall(true))
    }
    const ButtonActions = [
        {
            Actions: <div className='Hover-Refresh2 back-hover1 able-style'
                role="button"
                tabIndex={0} title='Send Email'
                onClick={() => CreateMail()}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        CreateMail()
                    }
                }}
                aria-label='mail'
            > <EmailIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className='Hover-Refresh2 back-hover1 able-style'
                role="button"
                tabIndex={0} title='Download PDF'
                onClick={() => handledownloadPdf()}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        handledownloadPdf()
                    }
                }}
                aria-label='pdf'
            > <PdfDownloadIcon height={20} width={20} /></div>
        }
    ]
    const moreAction = "No"
    const MoreAction = () => (<></>)
    const LeadInfos = {
        profile: undefined,
        Classname: " ",
        letterIcon: displayData?.quotesName,
        name: displayData?.quotesName,
        subName: `${displayData?.quotesNumber} `,
        mainAction: <>
            {displayData?.dealPipeline === "Won" ?
                <Button className="button_colors" size="small" style={{ width: "60%" }} onClick={() => SaledOrderPage()}>
                    {matchingSalesOrder ? <ViewDetailsIcon height={16} width={16} marginRight={5} /> : <FeatherIcon size={16} icon="plus-circle" className="text_iconspace" />}
                    {matchingSalesOrder ? "View Sales Order" : "Add Sales Order"}
                </Button> : undefined}
        </>,
    }

    const getDetailsDatas = useCallback(() => getData(quotesId), [quotesId]);
    const LeadDetails = (<QuotesFields Billing={Billing} billingAddress={billingAddress} Shipping={Shipping} shipingAddress={shipingAddress} displayData={displayData} getDetailsData={getDetailsDatas}
        pdfTheme={pdfTheme} onPdfThemeChange={handlePdfThemeChange} pdfThemes={THEMES} />);
    // Stable props so <PDFViewer> only regenerates the PDF when real data changes
    const pdfCalculation = useMemo(
        () => ({ total, dealDiscount, tax, adjustment, shippingss, grandTotal }),
        [total, dealDiscount, tax, adjustment, shippingss, grandTotal]
    );
    // Mount the viewer only after all data it needs has loaded (avoids render-per-prop during initial load)
    const pdfReady = Boolean(companyData && displayData && displayData !== "Create" && (!displayData?.accountId || accountJsonData) && ProductColumns.length > 0);
    const pdfDocument = useMemo(() => (pdfReady ? (
        <QuotationPdf data={displayData} accountJsonData={accountJsonData} profile={profile} companyData={companyData} tableItem={items} tableColum={ProductColumns} currencySettings={defaultCurrency} Calculation={pdfCalculation} theme={pdfTheme} />
    ) : null), [pdfReady, displayData, accountJsonData, profile, companyData, items, ProductColumns, defaultCurrency, pdfCalculation, pdfTheme]);
    const RelatedDetails = (
        <div style={{ height: "100vh" }}>
            {pdfDocument ? (
                <PDFViewer width="100%" height="100%">
                    {pdfDocument}
                </PDFViewer>
            ) : (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                    <Spin size="large" tip="Loading PDF..." />
                </div>
            )}
        </div>
    )
    const RightRelatedDetails = (<QuotesRight displayData={displayData} profile={profile} ViewDetailPage={ViewDetailPage} Role={Role} currencySettings={defaultCurrency} />)
    const EditOpenForDrawer = () => {
        setEdit(true)
        dispatch(setEditCall(true))
    }
    const CloseDrawer2 = () => {
        scroolup();
        getData(quotesId)
        setEditField(false)
        setEdit(false);
        dispatch(setEditCall(false))
    }
    const PageCancel1 = () => {
        if (FromPage === "EntityUpdate") {
            CloseDrawer2()
        }
        else {
            setCancelConfirmOpen(true)
        }
    }
    async function onSubmitApiCall(payload) {
        let hideMessage;
        try {
            hideMessage = message.loading("Loading...", 0);
            if (FromPage === "EntityUpdate") {
                const response = await updateQuotes(payload, quotesId)
                if (response.status === 200) {
                    if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                        setErrorData(response.data);
                        setIsModalVisible1(true);
                        loadingRef.current = false;
                        setDoubleClick(false)
                        hideMessage();
                    }
                    else {
                        const ownerChanged = displayData.quotesOwner !== payload.quotesOwner;
                        if (ownerChanged) {
                            hideMessage()
                            message.success(
                                <span>
                                    Quote <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                                </span>
                            );
                            dispatch(setEditCall(false));
                            history.push('/Home/quotes')
                        }
                        else {
                            getData1(quotesId, hideMessage, response)
                            scroolup()
                        }
                    }
                }
            }
            else {
                const response = await createQuotes(payload)
                if (response.status === 201) {
                    hideMessage();
                    if (ShortCut === "Shortcut") {
                        dispatch(setEditCall(false))
                        history.push('/Home/quotes')
                    }
                    message.success("Quotes created")
                    if (FromPage === "FromDeal") {
                        CallBackTrigger("CallBack")
                        dispatch(setEditCall(false))
                        history.push('/Home/quotes')
                    }
                    loadingRef.current = false;
                    setDoubleClick(false)
                    CloseDrawer()
                }
            }
        }
        catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
            message.error(error);
        }
    }
    const showConfirmForAccount = (values) => {
        const modal = Modal.confirm({
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                    <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
                    <span> Delivered State</span>
                </div>
            ),
            icon: null,
            className: "customice-confirm-modal",
            content: (
                <p>This quote is marked as <strong>Delivered</strong>. Any changes will require sending a revised version to the customer. Do you wish to continue with the changes?</p>
            ),
            centered: true,
            okText: "No",
            cancelText: "Yes",
            okButtonProps: {
                className: "gray-buttonModal"
            },
            cancelButtonProps: {
                className: "button_colorsModal"
            },
            okCancel: true,
            onOk() {
                loadingRef.current = false;
                setDoubleClick(false)
                modal.destroy();
                setEdit(false)
                setEditField(false)
                dispatch(setEditCall(false));
                scroolup()
                getData(quotesId)
                CloseDrawer()
            },
            onCancel() {
                onSubmitApiCall(values)
            },
        });
    };
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDoubleClick(true)
        if (!Billing) {
            message.error("Please enter the billing address");
            loadingRef.current = false;
            setDoubleClick(false)
            return;
        }
        if (!Shipping) {
            message.error("Please enter the shipping address");
            loadingRef.current = false;
            setDoubleClick(false)
            return;
        }
        const { subject, number, quoteOwner, status, deal, account, contact } = values;
        const convertedData = await Promise.all(
            items.map(async (role) => {
                const convertedRate = await (role.value !== undefined && role.value !== null && role.value !== ""
                    ? convertCurrency(ConvertRate, Number(role.value))
                    : role.value);
                const convertedTotalValue = await (role.total !== undefined && role.total !== null && role.total !== "" ?
                    convertCurrency(ConvertRate, Number(role.total))
                    : role.total);
                return {
                    ...role,
                    value: convertedRate,
                    total: convertedTotalValue,
                };
            })
        );
        const subtotals = total ? await convertCurrency(ConvertRate, Number(total)) : total;
        const adjustments = adjustment ? await convertCurrency(ConvertRate, Number(adjustment)) : adjustment;
        const shippingssss = (shippingss && shippingss !== "") ? await convertCurrency(ConvertRate, Number(shippingss)) : 0;
        const totals = grandTotal ? await convertCurrency(ConvertRate, Number(grandTotal)) : grandTotal;
        const quotesItems = {
            item: convertedData,
            subtotalamount: normalizeValue(subtotals),
            discountamount: normalizeValue(dealDiscount),
            taxAmount: normalizeValue(tax),
            shippingamount: normalizeValue(shippingssss),
            adjustmentAmount: normalizeValue(adjustments),
            grandTotalamount: normalizeValue(totals),
            dealData: normalizeValue(dealType)
        }
        const payload =
        {
            quotesName: normalizeValue(subject),
            quotesNumber: normalizeValue(number),
            quotesOwner: normalizeValue(quoteOwner),
            quotesStatus: status,
            issueDate: normalizeValue(issueDate),
            accountId: normalizeValue(account),
            dealId: normalizeValue(deal),
            grantTotal: normalizeValue(totals),
            conatctId: normalizeValue(contact),
            validUntil: normalizeValue(validDate),
            billingAddress,
            shippingAddress: shipingAddress,
            quotesItem: quotesItems,
            termsAndCondition: normalizeValue(content1),
            description: normalizeValue(content2),
            uploadFile: FILEList,
        }
        if (FromPage === "EntityUpdate") {
            if (displayData.quotesStatus === "Delivered" && (payload.quotesStatus !== "Draft" && payload.quotesStatus !== "Confirmed")) {
                const hasChanges = !deepEqual(displayData, payload, ["quotesStatus"]);
                if (hasChanges) {
                    showConfirmForAccount(payload)
                }
                else {
                    onSubmitApiCall(payload)
                }
            }
            else {
                onSubmitApiCall(payload)
            }
        }
        else {
            onSubmitApiCall(payload)
        }
    }
    const getRefreshtheTable = () => {
        setEdit(false)
        setEditField(false)
        dispatch(setEditCall(false));
        scroolup()
        getData(quotesId)
        CloseDrawer()
    }
    const handleChange1 = (val) => {
        setContent1(val);
    };
    const handleChange2 = (val) => {
        setContent2(val);
    };
    return (
        <>
            {FromPage === "EntityUpdate" ?
                <Main>
                    {displayData ? <>
                        {FromPage === "EntityUpdate" &&
                            <DetailsPage PageCancel={PageCancel} handleEditChange={handleEditChange} moreAction={moreAction}
                                DetailsPageMoreAction={<MoreAction />} ButtonActions={ButtonActions} Maincontent={LeadInfos} UpdateDataPage={undefined}
                                EntityTabDetails={LeadDetails} EntityRelatedTab={RelatedDetails} RightRelatedDetails={RightRelatedDetails}
                            />}
                    </>
                        :
                        <div className="spin">
                            <Spin />
                        </div>}
                </Main> : <></>}
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                title={
                    FromPage === "EntityUpdate" ?
                        <span>
                            Update Quote
                            {displayData?.quotesName && (
                                <>
                                    <span style={{
                                        margin: '0 10px',
                                        color: '#d9d9d9',
                                        fontWeight: 'normal'
                                    }}>|</span>
                                    <span style={{ fontWeight: 'normal' }}>
                                        {displayData?.quotesName}
                                    </span>
                                </>
                            )}
                        </span>
                        : "Create Quote"
                }
                closable={false}
                placement="right"
                open={editField}
                width="80%"
                extra={
                    <Space>
                        {!edit ?
                            <div className='Hover-Refresh2 back-hover1 able-style'
                                role="button"
                                tabIndex={0} title='Edit'
                                onClick={() => EditOpenForDrawer()}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        EditOpenForDrawer()
                                    }
                                }}
                                aria-label='edit'
                            > <EditIcon height={20} width={20} /></div> : <></>}
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => PageCancel1()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    PageCancel1()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space>
                }
                footer={
                    (uiReady && edit) ? [
                        <div className="form_action_button">
                            <Button
                                className="gray-button" size="small"
                                onClick={() => PageCancel1()}
                            >
                                <CancelIcon height={25} width={25} />Cancel
                            </Button>
                            {FromPage === "EntityUpdate" ?
                                <Button
                                    className="red-button" size="small"
                                    onClick={() => OnClickofDelete(quotesId)}
                                >
                                    <DeleteIcon height={25} width={25} />Delete
                                </Button> : <></>}
                            <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()} loading={doubleClick} disabled={doubleClick}>
                                {!doubleClick && <SaveIcon height={25} width={25} />}{FromPage === "EntityUpdate" ? "Update" : "Save"}
                            </Button>
                        </div>] : false
                }
            >
                {(uiReady && displayData) ? <Scrollbars ref={scrollRef} autoHide autoHideTimeout={500} autoHideDuration={200}>
                    <AddUser>
                        <div className="user-info-form">
                            <Form style={{ width: '100%' }} form={form} name="info" onFinish={onSubmit} onFinishFailed={onFinishFailed} colon={false}>
                                <BasicFormWrapper>
                                    <div className="add-product-block">
                                        <div style={{ margin: 40 }}>
                                            <Row gutter={15}>
                                                <Col xs={24}>
                                                    <div className="add-product-content">
                                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                            <Heading as="h5">Basic Information</Heading>
                                                            {UrlId !== undefined && UrlId !== null && UrlId[0] === "?QUOTES" &&
                                                                <div role="button" className="Hover-Refresh2 back-hover1 able-style"
                                                                    tabIndex={0}
                                                                    onClick={edit ? () => ConnectwithDeal(displayData) : undefined}
                                                                    onKeyDown={(event) => {
                                                                        if (event.key === 'Enter' || event.key === ' ') {
                                                                            ConnectwithDeal(displayData)
                                                                        }
                                                                    }}>
                                                                    <QUSOINIcon height={16} width={16} marginRight={5} /> Sync with Deal
                                                                </div>
                                                                // <Dropdown placement="bottomLeft" size="small" content={content}>
                                                                //     <FeatherIcon icon="more-vertical" size={25} style={{ marginTop: 6 }} />
                                                                // </Dropdown>
                                                            }
                                                        </div>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={8} style={{ marginBottom: 20 }} >
                                                                <Form.Item label="Quote Name" name="subject" id="subject" rules={edit ? [{
                                                                    required: true,
                                                                    transform: (value) => value?.trim(), message: 'Please enter the quote name'
                                                                }, {
                                                                    validator: (_, value) => {
                                                                        const error = validateShortText(value, 50);
                                                                        if (error) {
                                                                            return Promise.reject(new Error(error));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                }] : [{ required: false }]}>
                                                                    {edit ? <Input placeholder="Enter Quote Name" /> :
                                                                        <span>{displayData?.quotesName}</span>
                                                                    }
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }} >
                                                                <Form.Item label="Quote Number" name="number" id="number" rules={edit ? [{
                                                                    required: true,
                                                                    transform: (value) => value?.trim(), message: 'Please enter the quote number'
                                                                }, { validator: validateCode }] : [{ required: false }]}>
                                                                    {edit ? <Input placeholder="Enter Quote Number" /> :
                                                                        <span>{displayData?.quotesNumber}</span>
                                                                    }
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }} >
                                                                <Form.Item label="Quote Owner" name="quoteOwner" id="quoteOwner" rules={edit ? [{ required: true, message: 'Please select quote owner' }] : [{ required: false }]}>
                                                                    {edit ? <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }}
                                                                        placeholder="Select Quote Owner"
                                                                        showSearch optionLabelProp="label"
                                                                        filterOption={(input, option) => {
                                                                            const usernameElement = option.children.props.children[1].props.children[0];
                                                                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                const username = String(usernameElement.props.children);
                                                                                return username.toLowerCase().includes(input.toLowerCase());
                                                                            }
                                                                            return false;
                                                                        }
                                                                        }>
                                                                        {users}
                                                                    </Select> :
                                                                        <span className='user-info_image ListNavigate'
                                                                            role="button"
                                                                            tabIndex={0}
                                                                            onClick={() => displayData?.quotesOwner && ViewDetailPage(displayData?.quotesOwner, "USER")}
                                                                            onKeyDown={(event) => {
                                                                                if (event.key === 'Enter' || event.key === ' ') {
                                                                                    ViewDetailPage(displayData?.quotesOwner, "USER");
                                                                                }
                                                                            }}
                                                                        >{displayData?.quotesOwner && (
                                                                            displayData?.quoteOwnerProfilePic !== null && displayData?.quoteOwnerProfilePic
                                                                                !== undefined && displayData?.quoteOwnerProfilePic !== "" ?
                                                                                <figure>
                                                                                    <img style={{ width: "30px", height: "30px" }} src={displayData?.quoteOwnerProfilePic} alt="" />
                                                                                </figure>
                                                                                :
                                                                                <span className='list_span_Tag UserIcon'>
                                                                                    {displayData?.quoteOwnerFirstName?.slice(0, 1).toUpperCase()}
                                                                                </span>)
                                                                            }{displayData?.quotesOwner && (
                                                                                <figcaption>
                                                                                    {`${displayData?.quoteOwnerFirstName} ${displayData?.quoteOwnerLastName} `}
                                                                                </figcaption>)}</span>
                                                                    }
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }} >
                                                                <Form.Item label="Quote Status" name="status" id="status" rules={edit ? [{ required: true, message: 'Please select status' }] : [{ required: false }]} >
                                                                    {edit ? <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }}
                                                                        // disabled={matchingSalesOrder}
                                                                        allowClear placeholder="Please select quote status" onChange={(value) => form.setFieldsValue({ status: value || null })}>
                                                                        <Option value="Draft">Draft</Option>
                                                                        <Option value="Confirmed">Confirmed</Option>
                                                                        <Option value="Delivered">Delivered</Option>
                                                                        {/* <Option value="Negotiation">Negotiation</Option>
                                                                        <Option value="Closed Won">Closed Won</Option>
                                                                        <Option value="Closed Lost">Closed Lost</Option>
                                                                        <Option value="On Hold">On Hold</Option> */}
                                                                    </Select> :
                                                                        <span>{displayData?.quotesStatus}</span>
                                                                    }
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }} >
                                                                <Form.Item label="Account Name" name="account" id="account" rules={edit ? [{ required: true, message: 'Please select account name' }] : [{ required: false }]}>
                                                                    {edit ? <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }}
                                                                        placeholder="Select Account"
                                                                        // disabled={matchingSalesOrder}
                                                                        showSearch optionLabelProp="label"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) => {
                                                                            const usernameElement = option.children.props.children[1].props.children[0];
                                                                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                const username = String(usernameElement.props.children);
                                                                                return username.toLowerCase().includes(input.toLowerCase());
                                                                            }
                                                                            return false;
                                                                        }
                                                                        }
                                                                        onChange={(value) => getAccount(value)}
                                                                    >
                                                                        {account}
                                                                    </Select> : <span className='user-info_image ListNavigate'
                                                                        role="button"
                                                                        tabIndex={0}
                                                                        onClick={() => displayData?.accountId && ViewDetailPage(displayData?.accountId, "ACCOUNT")}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                                ViewDetailPage(displayData?.accountId, "ACCOUNT");
                                                                            }
                                                                        }}
                                                                    >{displayData?.accountId && (
                                                                        displayData?.accountProfile !== null && displayData?.accountProfile
                                                                            !== undefined && displayData?.accountProfile !== "" ?
                                                                            <figure>
                                                                                <img style={{ width: "30px", height: "30px" }} src={displayData?.accountProfile} alt="" />
                                                                            </figure>
                                                                            :
                                                                            <span className='list_span_Tag AccountIcon'>
                                                                                {displayData?.accountName?.slice(0, 1).toUpperCase()}
                                                                            </span>)
                                                                        }{displayData?.accountId && (
                                                                            <figcaption>
                                                                                {displayData?.accountName} ({displayData?.accountNumber})
                                                                            </figcaption>)}</span>
                                                                    }
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }} >
                                                                <Form.Item label="Deal Name" name="deal" id="deal" rules={edit ? [{ required: true, message: 'Please select deal name' }] : [{ required: false }]}>
                                                                    {edit ? <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }} onChange={(value) => getDeal(value)}
                                                                        placeholder="Select Deal"
                                                                        showSearch optionLabelProp="label"
                                                                        allowClear
                                                                        // disabled={matchingSalesOrder}
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) => {
                                                                            const usernameElement = option.children.props.children[1].props.children[0];
                                                                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                const username = String(usernameElement.props.children);
                                                                                return username.toLowerCase().includes(input.toLowerCase());
                                                                            }
                                                                            return false;
                                                                        }
                                                                        }
                                                                    >{deal}
                                                                    </Select> :
                                                                        <span className='user-info_image ListNavigate'
                                                                            role="button"
                                                                            tabIndex={0}
                                                                            onClick={() => displayData?.dealId && ViewDetailPage(displayData?.dealId, "DEAL")}
                                                                            onKeyDown={(event) => {
                                                                                if (event.key === 'Enter' || event.key === ' ') {
                                                                                    ViewDetailPage(displayData?.dealId, "DEAL");
                                                                                }
                                                                            }}
                                                                        >{displayData?.dealId && (
                                                                            displayData?.dealProfile !== null && displayData?.dealProfile
                                                                                !== undefined && displayData?.dealProfile !== "" ?
                                                                                <figure>
                                                                                    <img style={{ width: "30px", height: "30px" }} src={displayData?.dealProfile} alt="" />
                                                                                </figure>
                                                                                :
                                                                                <span className='list_span_Tag DealIcon'>
                                                                                    {displayData?.dealName?.slice(0, 1).toUpperCase()}
                                                                                </span>)
                                                                            }{displayData?.dealId && (
                                                                                <figcaption>
                                                                                    {displayData?.dealName}
                                                                                </figcaption>)}</span>}
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }} >
                                                                <Form.Item label="Contact Name" name="contact" id="contact"
                                                                    rules={edit ? [{ required: true, message: 'Please select contact name' }] : [{ required: false }]}
                                                                //  rules={edit && dealValue ? [{ required: true, message: 'Please select contact' }] : [{ required: false }]}
                                                                >
                                                                    {edit ? <Select getPopupContainer={getFieldPopupContainer} style={{ width: '100%' }}
                                                                        placeholder="Select Contact"
                                                                        showSearch allowClear optionLabelProp="label"
                                                                        optionFilterProp="children"
                                                                        // disabled={matchingSalesOrder}
                                                                        filterOption={(input, option) => {
                                                                            const usernameElement = option.children.props.children[1].props.children[0];
                                                                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                const username = String(usernameElement.props.children);
                                                                                return username.toLowerCase().includes(input.toLowerCase());
                                                                            }
                                                                            return false;
                                                                        }
                                                                        }
                                                                        onChange={(value) => onChangeContact(value)}
                                                                    >
                                                                        {contact}
                                                                    </Select> : <span className='user-info_image ListNavigate'
                                                                        role="button"
                                                                        tabIndex={0}
                                                                        onClick={() => displayData?.conatctId && ViewDetailPage(displayData?.conatctId, "CONTACT")}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter' || event.key === ' ') {
                                                                                ViewDetailPage(displayData?.conatctId, "CONTACT");
                                                                            }
                                                                        }}
                                                                    >{displayData?.conatctId && (
                                                                        displayData?.contactprofilePic !== null && displayData?.contactprofilePic
                                                                            !== undefined && displayData?.contactprofilePic !== "" ?
                                                                            <figure>
                                                                                <img style={{ width: "30px", height: "30px" }} src={displayData?.contactprofilePic} alt="" />
                                                                            </figure>
                                                                            :
                                                                            <span className='list_span_Tag ContactIcon'>
                                                                                {displayData?.contactFirstName?.slice(0, 1).toUpperCase()}
                                                                            </span>)
                                                                        }{displayData?.conatctId && (
                                                                            <figcaption>
                                                                                {`${displayData?.contactFirstName} ${displayData?.contactLastName} `}
                                                                            </figcaption>)}</span>
                                                                    }
                                                                </Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }} >
                                                                <Form.Item label="Issue Date" name="isssueDate" id="isssueDate" dependencies={["date"]} rules={edit ?
                                                                    [{ required: true, message: 'Please select validity date' }, ({ getFieldValue }) => ({
                                                                        validator(_, value) {
                                                                            const endDate = getFieldValue("date");
                                                                            if (!value || !endDate || value <= endDate) {
                                                                                return Promise.resolve();
                                                                            }
                                                                            return Promise.reject(new Error("Issue date cannot be after expiry date"));
                                                                        },
                                                                    })]
                                                                    : [{ required: false }]}>
                                                                    {edit ? <DatePicker allowClear={false} format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"} onChange={dealrestartDateChange2}
                                                                        disabledDate={disabledDate} />
                                                                        : <span >
                                                                            {displayData !== undefined && displayData?.issueDate ? moment(displayData !== undefined && displayData?.issueDate).format(profile.dateFormate) : (displayData !== undefined && displayData?.issueDate && moment(displayData !== undefined && displayData?.issueDate).format("YYYY-MM-DD"))}
                                                                        </span>}</Form.Item>
                                                            </Col>
                                                            <Col span={8} style={{ marginBottom: 20 }} >
                                                                <Form.Item label="Expiry Date" name="date" id="date" dependencies={["isssueDate"]} rules={edit ?
                                                                    [{ required: true, message: 'Please select validity date' },
                                                                    ({ getFieldValue }) => ({
                                                                        validator(_, value) {
                                                                            const startDate = getFieldValue("isssueDate");
                                                                            if (!value || !startDate || value >= startDate) {
                                                                                return Promise.resolve();
                                                                            }
                                                                            return Promise.reject(new Error("Expiry date cannot be before issue date"));
                                                                        },
                                                                    })]
                                                                    : [{ required: false }]}>
                                                                    {edit ? <DatePicker format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"} onChange={dealrestartDateChange} allowClear={false}
                                                                        disabledDate={disabledDate} />
                                                                        : <span >
                                                                            {displayData !== undefined && displayData?.validUntil ? moment(displayData !== undefined && displayData?.validUntil).format(profile.dateFormate) : (displayData !== undefined && displayData?.validUntil && moment(displayData !== undefined && displayData?.validUntil).format("YYYY-MM-DD"))}
                                                                        </span>}</Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={8}>
                                                                <Heading as="h5"><span style={{ color: "red" }}><sup>* </sup></span>Billing Address</Heading>
                                                                <Row gutter={30} style={{ marginBottom: 20, marginTop: 30 }}>
                                                                    <Col span={24} >
                                                                        {Billing ?
                                                                            <div className="addressCard" title="Edit Address"
                                                                                style={{ cursor: edit ? "pointer" : "default" }}
                                                                                role="button"
                                                                                tabIndex={0}
                                                                                onClick={() => edit ? addressPopup("Update", "Billing") : undefined}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter' || event.key === ' ') {
                                                                                        addressPopup("Update", "Billing")
                                                                                    }
                                                                                }}>
                                                                                <div style={{ padding: "20px 20px 15px", lineHeight: "inherit" }}>
                                                                                    <div style={{ fontSize: "18px", fontWeight: "600" }}>{`${billingAddress?.name} (${accountJsonData?.registration_number || accountJsonData?.account_number})`}</div>
                                                                                    <div>{billingAddress?.street}{billingAddress?.city && `, ${billingAddress?.city}`}</div>
                                                                                    {(billingAddress?.state || billingAddress?.zipcode) && (
                                                                                        <div>
                                                                                            {billingAddress?.state}
                                                                                            {billingAddress?.state && billingAddress?.zipcode ? ", " : ""}
                                                                                            {billingAddress?.zipcode}
                                                                                        </div>
                                                                                    )}
                                                                                    <div>{billingAddress?.country}</div>
                                                                                    <div style={{ fontSize: "14px", fontWeight: "600" }} className='ellipsisText' title={billingAddress?.email}>Email  : {billingAddress?.email}</div>
                                                                                    <div style={{ fontSize: "14px", fontWeight: "600" }} className='ellipsisText' title={billingAddress?.mobile}>Mobile : {billingAddress?.mobile}</div>
                                                                                </div>
                                                                            </div>
                                                                            :
                                                                            edit &&
                                                                            <div className="addressCard" style={{
                                                                                fontSize: 50,
                                                                                width: "80%",
                                                                                height: "175px",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center"
                                                                            }}>
                                                                                <PlusCircleOutlined style={{ color: "#7F7F7F" }} onClick={() => addressPopup("Create", "Billing")} />
                                                                            </div>
                                                                        }
                                                                    </Col>
                                                                </Row >
                                                            </Col>
                                                            <Col span={8}>
                                                                <Heading as="h5"><span style={{ color: "red" }}><sup>* </sup></span>Shipping Address</Heading>
                                                                <Row gutter={30} style={{ marginBottom: 20, marginTop: 30 }}>
                                                                    <Col span={24}>
                                                                        {Billing && Shipping ?
                                                                            <div className="addressCard" title="Edit Address"
                                                                                role="button" style={{ cursor: edit ? "pointer" : "default" }}
                                                                                tabIndex={0}
                                                                                onClick={() => edit ? addressPopup("Update", "Shipping") : undefined}
                                                                                onKeyDown={(event) => {
                                                                                    if (event.key === 'Enter' || event.key === ' ') {
                                                                                        addressPopup("Update", "Shipping")
                                                                                    }
                                                                                }}>
                                                                                <div style={{ padding: "20px 20px 15px", lineHeight: "inherit" }}>
                                                                                    <div style={{ fontSize: "18px", fontWeight: "600" }}>{`${shipingAddress?.name} (${accountJsonData?.registration_number || accountJsonData?.account_number})`}</div>
                                                                                    <div>{shipingAddress?.street}{shipingAddress?.city && `, ${shipingAddress?.city}`}</div>
                                                                                    {(shipingAddress?.state || shipingAddress?.zipcode) && (
                                                                                        <div>
                                                                                            {shipingAddress?.state}
                                                                                            {shipingAddress?.state && shipingAddress?.zipcode ? ", " : ""}
                                                                                            {shipingAddress?.zipcode}
                                                                                        </div>
                                                                                    )}
                                                                                    <div>{shipingAddress?.country}</div>
                                                                                    <div style={{ fontSize: "14px", fontWeight: "600" }} className='ellipsisText' title={shipingAddress?.email}>Email  : {shipingAddress?.email}</div>
                                                                                    <div style={{ fontSize: "14px", fontWeight: "600" }} className='ellipsisText' title={shipingAddress?.mobile}>Mobile : {shipingAddress?.mobile}</div>
                                                                                </div>
                                                                            </div>
                                                                            :
                                                                            edit &&
                                                                            <div className="addressCard" style={{
                                                                                fontSize: 50,
                                                                                width: "80%",
                                                                                height: "175px",
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center"
                                                                            }}>  <PlusCircleOutlined style={{ color: "#7F7F7F" }} onClick={() => Billing ? addressPopup("Create", "Shipping") : undefined} />
                                                                            </div>
                                                                        }
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </Row>
                                                        <Heading as="h5">Quote Items</Heading>
                                                        {items?.length > 0 ?
                                                            <>
                                                                <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                                    <div className="table-bordered leaderboard-table table-responsive QSITable" style={{ width: '100%' }}>
                                                                        <Table dataSource={items}
                                                                            columns={ProductColumns}
                                                                            // columns={disableFileds ? ProductColumns : editableColumns} 
                                                                            pagination={false} />
                                                                    </div>
                                                                </Row>
                                                                <Row justify="end" style={{ marginBottom: 20 }}>
                                                                    <Col xxl={10} xl={10} lg={10} md={10} sm={18} xs={24} offset={0}>
                                                                        <OrderSummary style={{ maxWidth: 450 }}>
                                                                            <div className="invoice-summary-inner" >
                                                                                <Row align="middle" gutter={30} style={{ marginBottom: 10 }}>
                                                                                    <Col lg={9} md={10} xs={24}>
                                                                                        <Form.Item label="Subtotal" />
                                                                                    </Col>
                                                                                    <Col lg={15} md={14} xs={24}>
                                                                                        <Form.Item label={`${defaultCurrency?.symbol} ${Number(total)?.toLocaleString()} `} />
                                                                                    </Col>
                                                                                </Row>
                                                                                <Row align="middle" gutter={30} style={{ marginBottom: 10 }}>
                                                                                    <Col lg={9} md={10} xs={24}>
                                                                                        <Form.Item label="Discount" />
                                                                                    </Col>
                                                                                    <Col lg={15} md={14} xs={24}>
                                                                                        <Form.Item label={`% ${dealDiscount} `} />
                                                                                        {/* <Input placeholder="Discount" prefix="%" disabled={!edit} value={dealDiscount} onChange={(e) => setDealDiscount(e.target.value)} /> */}
                                                                                    </Col>
                                                                                </Row>
                                                                                <Row align="middle" gutter={30} style={{ marginBottom: 10 }}>
                                                                                    <Col lg={9} md={10} xs={24}>
                                                                                        <Form.Item label="Tax" />
                                                                                    </Col>
                                                                                    <Col lg={15} md={14} xs={24}>
                                                                                        <Input placeholder="Tax" prefix="%" value={tax} disabled={!edit}
                                                                                            onBlur={(e) => {
                                                                                                if (e.target.value === '') {
                                                                                                    setTax(0);
                                                                                                }
                                                                                            }}
                                                                                            onChange={(e) => {
                                                                                                const inputValue = e.target.value;
                                                                                                const decimalLimit = defaultCurrency?.decimalOfCurrency || 2;
                                                                                                const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                                                                if (inputValue?.toString()?.length > 25) {
                                                                                                    message.error('Maximum 25 characters allowed');
                                                                                                    return;
                                                                                                }
                                                                                                if (!basicNumberCheck) {
                                                                                                    message.error('Please enter a valid number');
                                                                                                    return;
                                                                                                }
                                                                                                if (inputValue === ".") {
                                                                                                    message.error('Please enter a valid number');
                                                                                                    return;
                                                                                                }
                                                                                                const decimalRegex = new RegExp(`^\\d+(\\.\\d{0,${decimalLimit}})?$`);
                                                                                                if (inputValue && !decimalRegex.test(inputValue)) {
                                                                                                    message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                                                                    return;
                                                                                                }
                                                                                                const num = Number(inputValue);
                                                                                                if (inputValue && (num < 0 || num > 100)) {
                                                                                                    message.error('Percentage must be between 0 and 100');
                                                                                                    return;
                                                                                                }
                                                                                                setTax(inputValue);
                                                                                            }} />
                                                                                    </Col>
                                                                                </Row>
                                                                                <Row align="middle" gutter={30} style={{ marginBottom: 10 }}>
                                                                                    <Col lg={9} md={10} xs={24}>
                                                                                        <Form.Item label="Adjustment" />
                                                                                    </Col>
                                                                                    <Col lg={15} md={14} xs={24}>
                                                                                        <Input placeholder="Adjustment" disabled={!edit} prefix={defaultCurrency?.symbol} value={adjustment}
                                                                                            onBlur={(e) => {
                                                                                                if (e.target.value === '') {
                                                                                                    setAdjustment(0);
                                                                                                }
                                                                                            }}
                                                                                            onChange={(e) => {
                                                                                                const inputValue = e.target.value;
                                                                                                const decimalLimit = defaultCurrency?.decimalOfCurrency || 2;
                                                                                                const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                                                                if (inputValue?.toString()?.length > 25) {
                                                                                                    message.error('Maximum 25 characters allowed');
                                                                                                    return;
                                                                                                }
                                                                                                if (!basicNumberCheck) {
                                                                                                    message.error('Please enter a valid number');
                                                                                                    return;
                                                                                                }
                                                                                                if (inputValue === ".") {
                                                                                                    message.error('Please enter a valid number');
                                                                                                    return;
                                                                                                }
                                                                                                const decimalRegex = new RegExp(`^\\d+(\\.\\d{0,${decimalLimit}})?$`);
                                                                                                if (inputValue && !decimalRegex.test(inputValue)) {
                                                                                                    message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                                                                    return;
                                                                                                }
                                                                                                setAdjustment(inputValue)
                                                                                            }} />
                                                                                    </Col>
                                                                                </Row>
                                                                                <Row align="middle" gutter={30} style={{ marginBottom: 10 }}>
                                                                                    <Col lg={9} md={10} xs={24}>
                                                                                        <Form.Item label="Shipping/Handling" />
                                                                                    </Col>
                                                                                    <Col lg={15} md={14} xs={24}>
                                                                                        <Input placeholder="Shipping/Handling" disabled={!edit} prefix={defaultCurrency?.symbol} value={shippingss}
                                                                                            onBlur={(e) => {
                                                                                                if (e.target.value === '') {
                                                                                                    setShipping(0);
                                                                                                }
                                                                                            }}
                                                                                            onChange={(e) => {
                                                                                                const inputValue = e.target.value;
                                                                                                const decimalLimit = defaultCurrency?.decimalOfCurrency || 2;
                                                                                                const basicNumberCheck = /^\d*\.?\d*$/.test(inputValue);
                                                                                                if (inputValue?.toString()?.length > 25) {
                                                                                                    message.error('Maximum 25 characters allowed');
                                                                                                    return;
                                                                                                }
                                                                                                if (!basicNumberCheck) {
                                                                                                    message.error('Please enter a valid number');
                                                                                                    return;
                                                                                                }
                                                                                                if (inputValue === ".") {
                                                                                                    message.error('Please enter a valid number');
                                                                                                    return;
                                                                                                }
                                                                                                const decimalRegex = new RegExp(`^\\d+(\\.\\d{0,${decimalLimit}})?$`);
                                                                                                if (inputValue && !decimalRegex.test(inputValue)) {
                                                                                                    message.error(`Only up to ${decimalLimit} decimal place${decimalLimit > 1 ? 's' : ''} are allowed`);
                                                                                                    return;
                                                                                                }
                                                                                                setShipping(inputValue)
                                                                                            }}
                                                                                        />
                                                                                    </Col>
                                                                                </Row>
                                                                                <Row align="middle" gutter={30} style={{ marginTop: 20 }}>
                                                                                    <Col lg={9} md={10} xs={24}>
                                                                                        <Form.Item label="Grand Total" />
                                                                                    </Col>
                                                                                    <Col lg={15} md={14} xs={24}>
                                                                                        <Form.Item label={`${defaultCurrency?.symbol} ${Number(grandTotal)?.toLocaleString()} `} />
                                                                                    </Col>
                                                                                </Row>
                                                                            </div>
                                                                        </OrderSummary>
                                                                    </Col>
                                                                </Row>
                                                            </> : <Row gutter={30} style={{ margin: "20px 0px" }} />}
                                                        {/*  :
                                                                                <Row style={{ marginBottom:20, marginTop: 30 }}>
                                                                                    <Col span={1} />
                                                                                    <Col span={23}>
                                                                                        <AntdButton type="text" icon={<PlusCircleOutlined />} onClick={() => AddTableItems()}>
                                                                                            Add Items
                                                                                        </AntdButton>
                                                                                    </Col>
                                                                                </Row>
                                                                            } */}

                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={24} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Terms and Condition">
                                                                    {/* //  name="termsandCondition" id="termsandCondition" rules={
                                                                    //     [
                                                                    //         {
                                                                    //             validator: (_, value) => {
                                                                    //                 const error = validateDescriptionField(value, 2500);
                                                                    //                 if (error) {
                                                                    //                     return Promise.reject(new Error(error));
                                                                    //                 }
                                                                    //                 return Promise.resolve();
                                                                    //             },
                                                                    //         },
                                                                    //     ]
                                                                    // }> */}
                                                                    {edit ? <TinyMCEEditor
                                                                        placeholder="Enter Terms and Condition"
                                                                        content={content1}
                                                                        setContent={handleChange1}
                                                                        edit
                                                                        page="TextBoxs"
                                                                        height={150}
                                                                        selectedEntity="A"
                                                                    /> :
                                                                        <CustomHtmlParser html={content1} key={1} page="TextBoxs" />}
                                                                    {/* {edit ? <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter Terms and Condition' />
                                                                        : <span>{displayData?.termsAndCondition}</span>
                                                                    } */}
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={24} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Description">
                                                                    {/* name="description" id="description" rules={
                                                                    [
                                                                        {
                                                                            validator: (_, value) => {
                                                                                const error = validateDescriptionField(value, 2500);
                                                                                if (error) {
                                                                                    return Promise.reject(new Error(error));
                                                                                }
                                                                                return Promise.resolve();
                                                                            },
                                                                        },
                                                                    ]
                                                                }> */}
                                                                    {edit ? <TinyMCEEditor
                                                                        placeholder="Enter Description"
                                                                        content={content2}
                                                                        setContent={handleChange2}
                                                                        edit
                                                                        page="TextBoxs"
                                                                        height={150}
                                                                        selectedEntity="A2"
                                                                    /> :
                                                                        <CustomHtmlParser html={content2} key={2} page="TextBoxs" />}
                                                                    {/* {edit ? <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter Description' /> : <span>{displayData?.description}</span>} */}
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <RelatedDocUpload edit={edit} FILEList={FILEList} setFileList={setFileList} form={form} />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </BasicFormWrapper>
                            </Form>
                        </div>
                    </AddUser>
                </Scrollbars> :
                    <div className="spin">
                        <Spin />
                    </div>}
            </Drawer >
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page="Details" type="Quote" getCallBack={getRefreshtheTable} />}
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={CloseDrawer} />}
            <SalesOrderAdd UrlId={undefined} FromPage={createPageQuote} setCratePage={setCratePageQuote} dataForDeal={dataForQuote} />
            <ComposeMail mailOpen={mailOpen} close={closeMailComposr} entityName="quotes" entity="EntityPages" toId={[conatactDetails?.email]}
                AllData={{
                    accountJsonData,
                    data: displayData,
                    companyData,
                    tableItem: items,
                    tableColum: ProductColumns,
                    defaultCurrency, Calculation: { total, dealDiscount, tax, adjustment, shippingss, grandTotal }, theme: pdfTheme
                }} SubjectData={SubjectData} MailContent={MailContent} attachFile={attachFile} updateStatus={updateStatus} updateId={quotesId} />
            {confirmPopup && <ConfirmationPopup confirmPopup={confirmPopup} setConfirmPopup={setConfirmPopup} GetCallback={deleteMenu} deleteId={deleteId} />}
            {popupMessage && <DefaultMessagePopup messagePopup={popupMessage} setMessagePopup={setPopupMessage} pageType={pages} onNavigate={onnavigate} />}
            {popupOpen && <AddressPopup accountId={accountId} confirmPopup={popupOpen} setConfirmPopup={setPopupOpen} popupType={popupType} popupContent={popupContent} billingAddress={billingAddress} setBillingAddress={setBillingAddress} shipingAddress={shipingAddress} setShipingAddress={setShipingAddress} />}
            {isModalVisible && <DeleteConnectionPopup confirmPopup={isModalVisible} setConfirmPopup={HandleIsModalVisible} Respone={errorData} page="Details" type="Quote" getCallBack={getRefreshtheTable} />}
        </>
    );
}

AddNew.propTypes = {
    UrlId: PropTypes.array.isRequired,
    FromPage: PropTypes.string.isRequired,
    setCratePage: PropTypes.func.isRequired,
    ShortCut: PropTypes.string.isRequired,
    GetAll: PropTypes.func.isRequired,
    dataForDeal: PropTypes.object.isRequired,
    CallBackTrigger: PropTypes.func.isRequired,
};

export default AddNew;